// 已经处理过的经纬度
var grid = [{
  "lat": 0,
  "lon": 31.72
}, {
  "lat": -59.87,
  "lon": 164.91
}, {
  "lat": -59.98,
  "lon": 161.49
}, {
  "lat": -59.92,
  "lon": 154.39
}, {
  "lat": -59.74,
  "lon": 150.75
}, {
  "lat": -59.45,
  "lon": 147.09
}, {
  "lat": -59.05,
  "lon": 143.44
}, {
  "lat": -58.55,
  "lon": 139.83
}, {
  "lat": -57.94,
  "lon": 136.29
}, {
  "lat": -57.23,
  "lon": 132.83
}, {
  "lat": -56.41,
  "lon": 129.49
}, {
  "lat": -55.51,
  "lon": 126.28
}, {
  "lat": -54.52,
  "lon": 123.2
}, {
  "lat": -53.46,
  "lon": 120.27
}, {
  "lat": -52.33,
  "lon": 117.49
}, {
  "lat": -51.14,
  "lon": 114.87
}, {
  "lat": -49.91,
  "lon": 112.39
}, {
  "lat": -48.63,
  "lon": 110.06
}, {
  "lat": -47.33,
  "lon": 107.87
}, {
  "lat": -46,
  "lon": 105.82
}, {
  "lat": -44.66,
  "lon": 103.89
}, {
  "lat": -43.32,
  "lon": 102.08
}, {
  "lat": -41.97,
  "lon": 100.38
}, {
  "lat": -40.62,
  "lon": 98.78
}, {
  "lat": -39.29,
  "lon": 97.29
}, {
  "lat": -37.97,
  "lon": 95.88
}, {
  "lat": -36.68,
  "lon": 94.56
}, {
  "lat": -35.4,
  "lon": 93.32
}, {
  "lat": -34.14,
  "lon": 92.15
}, {
  "lat": -63.4,
  "lon": 176.69
}, {
  "lat": -62.22,
  "lon": 173.63
}, {
  "lat": -60.98,
  "lon": 170.81
}, {
  "lat": -65.06,
  "lon": 176.44
}, {
  "lat": -63.85,
  "lon": 173.17
}, {
  "lat": -62.58,
  "lon": 170.16
}, {
  "lat": -61.25,
  "lon": 167.42
}, {
  "lat": -66.76,
  "lon": 176.14
}, {
  "lat": -65.53,
  "lon": 172.62
}, {
  "lat": -64.23,
  "lon": 169.42
}, {
  "lat": -62.86,
  "lon": 166.52
}, {
  "lat": -61.44,
  "lon": 163.88
}, {
  "lat": -68.5,
  "lon": 175.79
}, {
  "lat": -67.25,
  "lon": 171.99
}, {
  "lat": -65.91,
  "lon": 168.57
}, {
  "lat": -64.51,
  "lon": 165.49
}, {
  "lat": -63.04,
  "lon": 162.72
}, {
  "lat": -61.54,
  "lon": 160.22
}, {
  "lat": -69.01,
  "lon": 171.24
}, {
  "lat": -67.64,
  "lon": 167.56
}, {
  "lat": -66.19,
  "lon": 164.28
}, {
  "lat": -64.68,
  "lon": 161.37
}, {
  "lat": -63.13,
  "lon": 158.78
}, {
  "lat": -61.53,
  "lon": 156.46
}, {
  "lat": -69.41,
  "lon": 166.36
}, {
  "lat": -67.92,
  "lon": 162.87
}, {
  "lat": -66.36,
  "lon": 159.81
}, {
  "lat": -64.75,
  "lon": 157.12
}, {
  "lat": -63.1,
  "lon": 154.74
}, {
  "lat": -61.42,
  "lon": 152.63
}, {
  "lat": -69.66,
  "lon": 161.19
}, {
  "lat": -68.05,
  "lon": 157.98
}, {
  "lat": -66.39,
  "lon": 155.19
}, {
  "lat": -64.68,
  "lon": 152.76
}, {
  "lat": -62.95,
  "lon": 150.63
}, {
  "lat": -61.2,
  "lon": 148.75
}, {
  "lat": -69.77,
  "lon": 155.8
}, {
  "lat": -68.04,
  "lon": 152.93
}, {
  "lat": -66.28,
  "lon": 150.48
}, {
  "lat": -64.49,
  "lon": 148.35
}, {
  "lat": -62.68,
  "lon": 146.5
}, {
  "lat": -60.86,
  "lon": 144.87
}, {
  "lat": -69.7,
  "lon": 150.27
}, {
  "lat": -67.87,
  "lon": 147.82
}, {
  "lat": -66.02,
  "lon": 145.73
}, {
  "lat": -64.15,
  "lon": 143.94
}, {
  "lat": -62.28,
  "lon": 142.39
}, {
  "lat": -60.41,
  "lon": 141.03
}, {
  "lat": -71.34,
  "lon": 147.09
}, {
  "lat": -69.45,
  "lon": 144.71
}, {
  "lat": -67.54,
  "lon": 142.71
}, {
  "lat": -65.61,
  "lon": 141.03
}, {
  "lat": -63.68,
  "lon": 139.58
}, {
  "lat": -61.75,
  "lon": 138.33
}, {
  "lat": -59.84,
  "lon": 137.24
}, {
  "lat": -74.87,
  "lon": 146.01
}, {
  "lat": -72.96,
  "lon": 143.25
}, {
  "lat": -71,
  "lon": 141.03
}, {
  "lat": -69.03,
  "lon": 139.21
}, {
  "lat": -67.04,
  "lon": 137.69
}, {
  "lat": -65.05,
  "lon": 136.42
}, {
  "lat": -63.07,
  "lon": 135.32
}, {
  "lat": -61.1,
  "lon": 134.38
}, {
  "lat": -59.15,
  "lon": 133.56
}, {
  "lat": -74.51,
  "lon": 138.57
}, {
  "lat": -70.46,
  "lon": 135.12
}, {
  "lat": -68.42,
  "lon": 133.87
}, {
  "lat": -66.38,
  "lon": 132.83
}, {
  "lat": -64.35,
  "lon": 131.95
}, {
  "lat": -62.33,
  "lon": 131.2
}, {
  "lat": -60.33,
  "lon": 130.55
}, {
  "lat": -58.36,
  "lon": 129.99
}, {
  "lat": -71.81,
  "lon": 130.36
}, {
  "lat": -69.72,
  "lon": 129.49
}, {
  "lat": -67.64,
  "lon": 128.78
}, {
  "lat": -65.56,
  "lon": 128.19
}, {
  "lat": -63.5,
  "lon": 127.69
}, {
  "lat": -61.46,
  "lon": 127.26
}, {
  "lat": -59.45,
  "lon": 126.89
}, {
  "lat": -57.46,
  "lon": 126.56
}, {
  "lat": -73.04,
  "lon": 124.81
}, {
  "lat": -70.92,
  "lon": 124.48
}, {
  "lat": -68.8,
  "lon": 124.21
}, {
  "lat": -66.7,
  "lon": 123.99
}, {
  "lat": -64.6,
  "lon": 123.8
}, {
  "lat": -62.53,
  "lon": 123.65
}, {
  "lat": -60.48,
  "lon": 123.51
}, {
  "lat": -58.46,
  "lon": 123.39
}, {
  "lat": -56.47,
  "lon": 123.29
}, {
  "lat": -71.98,
  "lon": 118.78
}, {
  "lat": -69.85,
  "lon": 119.08
}, {
  "lat": -67.72,
  "lon": 119.33
}, {
  "lat": -65.61,
  "lon": 119.53
}, {
  "lat": -63.51,
  "lon": 119.7
}, {
  "lat": -61.44,
  "lon": 119.85
}, {
  "lat": -59.39,
  "lon": 119.98
}, {
  "lat": -57.38,
  "lon": 120.09
}, {
  "lat": -55.4,
  "lon": 120.19
}, {
  "lat": -74.97,
  "lon": 111.12
}, {
  "lat": -72.86,
  "lon": 112.39
}, {
  "lat": -70.74,
  "lon": 113.39
}, {
  "lat": -68.62,
  "lon": 114.2
}, {
  "lat": -66.5,
  "lon": 114.87
}, {
  "lat": -64.39,
  "lon": 115.43
}, {
  "lat": -62.31,
  "lon": 115.9
}, {
  "lat": -60.24,
  "lon": 116.31
}, {
  "lat": -58.21,
  "lon": 116.66
}, {
  "lat": -56.21,
  "lon": 116.97
}, {
  "lat": -54.25,
  "lon": 117.25
}, {
  "lat": -79.55,
  "lon": 95.88
}, {
  "lat": -77.6,
  "lon": 100.01
}, {
  "lat": -75.58,
  "lon": 103.05
}, {
  "lat": -73.53,
  "lon": 105.36
}, {
  "lat": -71.44,
  "lon": 107.17
}, {
  "lat": -69.35,
  "lon": 108.63
}, {
  "lat": -67.25,
  "lon": 109.83
}, {
  "lat": -65.15,
  "lon": 110.82
}, {
  "lat": -63.07,
  "lon": 111.67
}, {
  "lat": -61,
  "lon": 112.39
}, {
  "lat": -58.96,
  "lon": 113.02
}, {
  "lat": -56.95,
  "lon": 113.57
}, {
  "lat": -54.97,
  "lon": 114.05
}, {
  "lat": -53.04,
  "lon": 114.48
}, {
  "lat": -75.9,
  "lon": 94.42
}, {
  "lat": -73.94,
  "lon": 97.82
}, {
  "lat": -71.93,
  "lon": 100.5
}, {
  "lat": -69.89,
  "lon": 102.67
}, {
  "lat": -67.83,
  "lon": 104.44
}, {
  "lat": -65.77,
  "lon": 105.92
}, {
  "lat": -63.7,
  "lon": 107.17
}, {
  "lat": -61.65,
  "lon": 108.24
}, {
  "lat": -59.61,
  "lon": 109.17
}, {
  "lat": -57.6,
  "lon": 109.98
}, {
  "lat": -55.62,
  "lon": 110.69
}, {
  "lat": -53.68,
  "lon": 111.32
}, {
  "lat": -51.77,
  "lon": 111.89
}, {
  "lat": -80.43,
  "lon": 63.69
}, {
  "lat": -74.08,
  "lon": 90
}, {
  "lat": -72.19,
  "lon": 93.54
}, {
  "lat": -70.23,
  "lon": 96.41
}, {
  "lat": -68.24,
  "lon": 98.78
}, {
  "lat": -66.22,
  "lon": 100.77
}, {
  "lat": -64.2,
  "lon": 102.45
}, {
  "lat": -62.17,
  "lon": 103.89
}, {
  "lat": -60.16,
  "lon": 105.13
}, {
  "lat": -58.16,
  "lon": 106.22
}, {
  "lat": -56.18,
  "lon": 107.17
}, {
  "lat": -54.24,
  "lon": 108.02
}, {
  "lat": -52.33,
  "lon": 108.77
}, {
  "lat": -50.46,
  "lon": 109.45
}, {
  "lat": -80.2,
  "lon": 19.78
}, {
  "lat": -73.94,
  "lon": 82.18
}, {
  "lat": -72.19,
  "lon": 86.46
}, {
  "lat": -70.35,
  "lon": 90
}, {
  "lat": -68.44,
  "lon": 92.95
}, {
  "lat": -66.5,
  "lon": 95.43
}, {
  "lat": -64.53,
  "lon": 97.54
}, {
  "lat": -62.55,
  "lon": 99.36
}, {
  "lat": -60.57,
  "lon": 100.93
}, {
  "lat": -58.6,
  "lon": 102.31
}, {
  "lat": -56.65,
  "lon": 103.51
}, {
  "lat": -54.71,
  "lon": 104.59
}, {
  "lat": -52.81,
  "lon": 105.54
}, {
  "lat": -50.94,
  "lon": 106.4
}, {
  "lat": -49.12,
  "lon": 107.17
}, {
  "lat": -78.31,
  "lon": 16.39
}, {
  "lat": -76.23,
  "lon": 62.09
}, {
  "lat": -71.93,
  "lon": 79.5
}, {
  "lat": -70.23,
  "lon": 83.59
}, {
  "lat": -68.44,
  "lon": 87.05
}, {
  "lat": -66.6,
  "lon": 90
}, {
  "lat": -64.7,
  "lon": 92.53
}, {
  "lat": -62.79,
  "lon": 94.71
}, {
  "lat": -60.86,
  "lon": 96.61
}, {
  "lat": -58.93,
  "lon": 98.27
}, {
  "lat": -57,
  "lon": 99.74
}, {
  "lat": -55.09,
  "lon": 101.04
}, {
  "lat": -53.21,
  "lon": 102.21
}, {
  "lat": -51.35,
  "lon": 103.25
}, {
  "lat": -49.53,
  "lon": 104.19
}, {
  "lat": -47.75,
  "lon": 105.04
}, {
  "lat": -72.86,
  "lon": 67.61
}, {
  "lat": -71.44,
  "lon": 72.83
}, {
  "lat": -69.89,
  "lon": 77.33
}, {
  "lat": -68.24,
  "lon": 81.22
}, {
  "lat": -66.5,
  "lon": 84.57
}, {
  "lat": -64.7,
  "lon": 87.47
}, {
  "lat": -62.87,
  "lon": 90
}, {
  "lat": -61,
  "lon": 92.21
}, {
  "lat": -59.12,
  "lon": 94.16
}, {
  "lat": -57.24,
  "lon": 95.88
}, {
  "lat": -55.37,
  "lon": 97.41
}, {
  "lat": -53.51,
  "lon": 98.78
}, {
  "lat": -51.68,
  "lon": 100.01
}, {
  "lat": -49.87,
  "lon": 101.13
}, {
  "lat": -48.09,
  "lon": 102.13
}, {
  "lat": -46.36,
  "lon": 103.05
}, {
  "lat": -73.04,
  "lon": 55.19
}, {
  "lat": -70.74,
  "lon": 66.61
}, {
  "lat": -69.35,
  "lon": 71.37
}, {
  "lat": -67.83,
  "lon": 75.56
}, {
  "lat": -66.22,
  "lon": 79.23
}, {
  "lat": -64.53,
  "lon": 82.46
}, {
  "lat": -62.79,
  "lon": 85.29
}, {
  "lat": -61,
  "lon": 87.79
}, {
  "lat": -59.19,
  "lon": 90
}, {
  "lat": -57.37,
  "lon": 91.97
}, {
  "lat": -55.54,
  "lon": 93.72
}, {
  "lat": -53.72,
  "lon": 95.3
}, {
  "lat": -51.91,
  "lon": 96.71
}, {
  "lat": -50.13,
  "lon": 98
}, {
  "lat": -48.37,
  "lon": 99.16
}, {
  "lat": -46.65,
  "lon": 100.22
}, {
  "lat": -44.96,
  "lon": 101.19
}, {
  "lat": -70.92,
  "lon": 55.52
}, {
  "lat": -69.85,
  "lon": 60.92
}, {
  "lat": -68.62,
  "lon": 65.8
}, {
  "lat": -67.25,
  "lon": 70.17
}, {
  "lat": -65.77,
  "lon": 74.08
}, {
  "lat": -64.2,
  "lon": 77.55
}, {
  "lat": -62.55,
  "lon": 80.64
}, {
  "lat": -60.86,
  "lon": 83.39
}, {
  "lat": -59.12,
  "lon": 85.84
}, {
  "lat": -57.37,
  "lon": 88.03
}, {
  "lat": -55.59,
  "lon": 90
}, {
  "lat": -53.82,
  "lon": 91.77
}, {
  "lat": -52.06,
  "lon": 93.37
}, {
  "lat": -50.3,
  "lon": 94.82
}, {
  "lat": -48.57,
  "lon": 96.13
}, {
  "lat": -46.87,
  "lon": 97.34
}, {
  "lat": -45.2,
  "lon": 98.44
}, {
  "lat": -43.56,
  "lon": 99.45
}, {
  "lat": -67.72,
  "lon": 60.67
}, {
  "lat": -66.5,
  "lon": 65.13
}, {
  "lat": -65.15,
  "lon": 69.18
}, {
  "lat": -63.7,
  "lon": 72.83
}, {
  "lat": -62.17,
  "lon": 76.11
}, {
  "lat": -60.57,
  "lon": 79.07
}, {
  "lat": -58.93,
  "lon": 81.73
}, {
  "lat": -57.24,
  "lon": 84.12
}, {
  "lat": -55.54,
  "lon": 86.28
}, {
  "lat": -53.82,
  "lon": 88.23
}, {
  "lat": -52.1,
  "lon": 90
}, {
  "lat": -50.39,
  "lon": 91.61
}, {
  "lat": -48.7,
  "lon": 93.08
}, {
  "lat": -47.02,
  "lon": 94.42
}, {
  "lat": -45.37,
  "lon": 95.65
}, {
  "lat": -43.75,
  "lon": 96.78
}, {
  "lat": -42.17,
  "lon": 97.82
}, {
  "lat": -69.66,
  "lon": 18.81
}, {
  "lat": -69.77,
  "lon": 24.2
}, {
  "lat": -69.7,
  "lon": 29.73
}, {
  "lat": -69.45,
  "lon": 35.29
}, {
  "lat": -68.42,
  "lon": 46.13
}, {
  "lat": -67.64,
  "lon": 51.22
}, {
  "lat": -66.7,
  "lon": 56.01
}, {
  "lat": -65.61,
  "lon": 60.47
}, {
  "lat": -64.39,
  "lon": 64.57
}, {
  "lat": -63.07,
  "lon": 68.33
}, {
  "lat": -61.65,
  "lon": 71.76
}, {
  "lat": -60.16,
  "lon": 74.87
}, {
  "lat": -58.6,
  "lon": 77.69
}, {
  "lat": -57,
  "lon": 80.26
}, {
  "lat": -55.37,
  "lon": 82.59
}, {
  "lat": -53.72,
  "lon": 84.7
}, {
  "lat": -52.06,
  "lon": 86.63
}, {
  "lat": -50.39,
  "lon": 88.39
}, {
  "lat": -48.74,
  "lon": 90
}, {
  "lat": -47.1,
  "lon": 91.48
}, {
  "lat": -45.48,
  "lon": 92.83
}, {
  "lat": -43.88,
  "lon": 94.08
}, {
  "lat": -42.32,
  "lon": 95.23
}, {
  "lat": -40.79,
  "lon": 96.3
}, {
  "lat": -67.92,
  "lon": 17.13
}, {
  "lat": -68.05,
  "lon": 22.02
}, {
  "lat": -68.04,
  "lon": 27.07
}, {
  "lat": -67.87,
  "lon": 32.18
}, {
  "lat": -67.54,
  "lon": 37.29
}, {
  "lat": -67.04,
  "lon": 42.31
}, {
  "lat": -66.38,
  "lon": 47.17
}, {
  "lat": -65.56,
  "lon": 51.81
}, {
  "lat": -64.6,
  "lon": 56.2
}, {
  "lat": -63.51,
  "lon": 60.3
}, {
  "lat": -62.31,
  "lon": 64.1
}, {
  "lat": -61,
  "lon": 67.61
}, {
  "lat": -59.61,
  "lon": 70.83
}, {
  "lat": -58.16,
  "lon": 73.78
}, {
  "lat": -56.65,
  "lon": 76.49
}, {
  "lat": -55.09,
  "lon": 78.96
}, {
  "lat": -53.51,
  "lon": 81.22
}, {
  "lat": -51.91,
  "lon": 83.29
}, {
  "lat": -50.3,
  "lon": 85.18
}, {
  "lat": -48.7,
  "lon": 86.92
}, {
  "lat": -47.1,
  "lon": 88.52
}, {
  "lat": -45.51,
  "lon": 90
}, {
  "lat": -43.95,
  "lon": 91.36
}, {
  "lat": -42.41,
  "lon": 92.62
}, {
  "lat": -40.9,
  "lon": 93.79
}, {
  "lat": -39.42,
  "lon": 94.87
}, {
  "lat": -66.19,
  "lon": 15.72
}, {
  "lat": -66.36,
  "lon": 20.19
}, {
  "lat": -66.39,
  "lon": 24.81
}, {
  "lat": -66.28,
  "lon": 29.52
}, {
  "lat": -66.02,
  "lon": 34.27
}, {
  "lat": -65.61,
  "lon": 38.97
}, {
  "lat": -65.05,
  "lon": 43.58
}, {
  "lat": -64.35,
  "lon": 48.05
}, {
  "lat": -63.5,
  "lon": 52.31
}, {
  "lat": -62.53,
  "lon": 56.35
}, {
  "lat": -61.44,
  "lon": 60.15
}, {
  "lat": -60.24,
  "lon": 63.69
}, {
  "lat": -58.96,
  "lon": 66.98
}, {
  "lat": -57.6,
  "lon": 70.02
}, {
  "lat": -56.18,
  "lon": 72.83
}, {
  "lat": -54.71,
  "lon": 75.41
}, {
  "lat": -53.21,
  "lon": 77.79
}, {
  "lat": -51.68,
  "lon": 79.99
}, {
  "lat": -50.13,
  "lon": 82
}, {
  "lat": -48.57,
  "lon": 83.87
}, {
  "lat": -47.02,
  "lon": 85.58
}, {
  "lat": -45.48,
  "lon": 87.17
}, {
  "lat": -43.95,
  "lon": 88.64
}, {
  "lat": -42.44,
  "lon": 90
}, {
  "lat": -40.95,
  "lon": 91.26
}, {
  "lat": -39.49,
  "lon": 92.44
}, {
  "lat": -38.07,
  "lon": 93.54
}, {
  "lat": -64.23,
  "lon": 10.58
}, {
  "lat": -64.51,
  "lon": 14.51
}, {
  "lat": -64.68,
  "lon": 18.63
}, {
  "lat": -64.68,
  "lon": 27.24
}, {
  "lat": -64.49,
  "lon": 31.65
}, {
  "lat": -64.15,
  "lon": 36.06
}, {
  "lat": -63.68,
  "lon": 40.42
}, {
  "lat": -63.07,
  "lon": 44.68
}, {
  "lat": -62.33,
  "lon": 48.8
}, {
  "lat": -61.46,
  "lon": 52.74
}, {
  "lat": -60.48,
  "lon": 56.49
}, {
  "lat": -59.39,
  "lon": 60.02
}, {
  "lat": -58.21,
  "lon": 63.34
}, {
  "lat": -56.95,
  "lon": 66.43
}, {
  "lat": -55.62,
  "lon": 69.31
}, {
  "lat": -54.24,
  "lon": 71.98
}, {
  "lat": -52.81,
  "lon": 74.46
}, {
  "lat": -51.35,
  "lon": 76.75
}, {
  "lat": -49.87,
  "lon": 78.87
}, {
  "lat": -48.37,
  "lon": 80.84
}, {
  "lat": -46.87,
  "lon": 82.66
}, {
  "lat": -45.37,
  "lon": 84.35
}, {
  "lat": -43.88,
  "lon": 85.92
}, {
  "lat": -42.41,
  "lon": 87.38
}, {
  "lat": -40.95,
  "lon": 88.74
}, {
  "lat": -39.52,
  "lon": 90
}, {
  "lat": -38.12,
  "lon": 91.18
}, {
  "lat": -36.74,
  "lon": 92.28
}, {
  "lat": -62.22,
  "lon": 6.37
}, {
  "lat": -62.58,
  "lon": 9.84
}, {
  "lat": -62.86,
  "lon": 13.48
}, {
  "lat": -63.04,
  "lon": 17.28
}, {
  "lat": -63.13,
  "lon": 21.22
}, {
  "lat": -63.1,
  "lon": 25.26
}, {
  "lat": -62.95,
  "lon": 29.37
}, {
  "lat": -62.68,
  "lon": 33.5
}, {
  "lat": -62.28,
  "lon": 37.61
}, {
  "lat": -61.75,
  "lon": 41.67
}, {
  "lat": -61.1,
  "lon": 45.62
}, {
  "lat": -60.33,
  "lon": 49.45
}, {
  "lat": -59.45,
  "lon": 53.11
}, {
  "lat": -58.46,
  "lon": 56.61
}, {
  "lat": -57.38,
  "lon": 59.91
}, {
  "lat": -56.21,
  "lon": 63.03
}, {
  "lat": -54.97,
  "lon": 65.95
}, {
  "lat": -53.68,
  "lon": 68.68
}, {
  "lat": -52.33,
  "lon": 71.23
}, {
  "lat": -50.94,
  "lon": 73.6
}, {
  "lat": -49.53,
  "lon": 75.81
}, {
  "lat": -48.09,
  "lon": 77.87
}, {
  "lat": -46.65,
  "lon": 79.78
}, {
  "lat": -45.2,
  "lon": 81.56
}, {
  "lat": -43.75,
  "lon": 83.22
}, {
  "lat": -42.32,
  "lon": 84.77
}, {
  "lat": -40.9,
  "lon": 86.21
}, {
  "lat": -39.49,
  "lon": 87.56
}, {
  "lat": -38.12,
  "lon": 88.82
}, {
  "lat": -36.76,
  "lon": 90
}, {
  "lat": -35.44,
  "lon": 91.11
}, {
  "lat": -60.64,
  "lon": 5.96
}, {
  "lat": -60.98,
  "lon": 9.19
}, {
  "lat": -61.25,
  "lon": 12.58
}, {
  "lat": -61.44,
  "lon": 16.12
}, {
  "lat": -61.53,
  "lon": 23.54
}, {
  "lat": -61.42,
  "lon": 27.37
}, {
  "lat": -61.2,
  "lon": 31.25
}, {
  "lat": -60.86,
  "lon": 35.13
}, {
  "lat": -60.41,
  "lon": 38.97
}, {
  "lat": -59.84,
  "lon": 42.76
}, {
  "lat": -59.15,
  "lon": 46.44
}, {
  "lat": -58.36,
  "lon": 50.01
}, {
  "lat": -57.46,
  "lon": 53.44
}, {
  "lat": -56.47,
  "lon": 56.71
}, {
  "lat": -55.4,
  "lon": 59.81
}, {
  "lat": -54.25,
  "lon": 62.75
}, {
  "lat": -53.04,
  "lon": 65.52
}, {
  "lat": -51.77,
  "lon": 68.11
}, {
  "lat": -50.46,
  "lon": 70.55
}, {
  "lat": -49.12,
  "lon": 72.83
}, {
  "lat": -47.75,
  "lon": 74.96
}, {
  "lat": -46.36,
  "lon": 76.95
}, {
  "lat": -44.96,
  "lon": 78.81
}, {
  "lat": -43.56,
  "lon": 80.55
}, {
  "lat": -42.17,
  "lon": 82.18
}, {
  "lat": -40.79,
  "lon": 83.7
}, {
  "lat": -39.42,
  "lon": 85.13
}, {
  "lat": -38.07,
  "lon": 86.46
}, {
  "lat": -36.74,
  "lon": 87.72
}, {
  "lat": -35.44,
  "lon": 88.89
}, {
  "lat": -34.16,
  "lon": 90
}, {
  "lat": -59.1,
  "lon": 5.6
}, {
  "lat": -59.42,
  "lon": 8.63
}, {
  "lat": -59.68,
  "lon": 11.79
}, {
  "lat": -59.87,
  "lon": 15.09
}, {
  "lat": -59.98,
  "lon": 18.51
}, {
  "lat": -60,
  "lon": 22.02
}, {
  "lat": -59.92,
  "lon": 25.61
}, {
  "lat": -59.74,
  "lon": 29.25
}, {
  "lat": -59.45,
  "lon": 32.91
}, {
  "lat": -59.05,
  "lon": 36.56
}, {
  "lat": -58.55,
  "lon": 40.17
}, {
  "lat": -57.94,
  "lon": 43.71
}, {
  "lat": -57.23,
  "lon": 47.17
}, {
  "lat": -56.41,
  "lon": 50.51
}, {
  "lat": -55.51,
  "lon": 53.72
}, {
  "lat": -54.52,
  "lon": 56.8
}, {
  "lat": -53.46,
  "lon": 59.73
}, {
  "lat": -52.33,
  "lon": 62.51
}, {
  "lat": -51.14,
  "lon": 65.13
}, {
  "lat": -49.91,
  "lon": 67.61
}, {
  "lat": -48.63,
  "lon": 69.94
}, {
  "lat": -47.33,
  "lon": 72.13
}, {
  "lat": -46,
  "lon": 74.18
}, {
  "lat": -44.66,
  "lon": 76.11
}, {
  "lat": -43.32,
  "lon": 77.92
}, {
  "lat": -41.97,
  "lon": 79.62
}, {
  "lat": -40.62,
  "lon": 81.22
}, {
  "lat": -39.29,
  "lon": 82.71
}, {
  "lat": -37.97,
  "lon": 84.12
}, {
  "lat": -36.68,
  "lon": 85.44
}, {
  "lat": -35.4,
  "lon": 86.68
}, {
  "lat": -34.14,
  "lon": 87.85
}, {
  "lat": -53.08,
  "lon": 6.09
}, {
  "lat": -51.64,
  "lon": 7.48
}, {
  "lat": -50.15,
  "lon": 8.81
}, {
  "lat": -48.6,
  "lon": 10.09
}, {
  "lat": -47,
  "lon": 11.33
}, {
  "lat": -45.36,
  "lon": 12.51
}, {
  "lat": -43.67,
  "lon": 13.65
}, {
  "lat": -41.94,
  "lon": 14.74
}, {
  "lat": -40.17,
  "lon": 15.8
}, {
  "lat": -38.37,
  "lon": 16.81
}, {
  "lat": -30.94,
  "lon": 20.48
}, {
  "lat": -29.05,
  "lon": 21.32
}, {
  "lat": -27.16,
  "lon": 22.12
}, {
  "lat": -25.27,
  "lon": 22.89
}, {
  "lat": -23.39,
  "lon": 23.64
}, {
  "lat": -21.52,
  "lon": 24.36
}, {
  "lat": -19.67,
  "lon": 25.05
}, {
  "lat": -17.84,
  "lon": 25.72
}, {
  "lat": -16.03,
  "lon": 26.36
}, {
  "lat": -14.26,
  "lon": 26.98
}, {
  "lat": -12.52,
  "lon": 27.58
}, {
  "lat": -10.81,
  "lon": 28.16
}, {
  "lat": -9.14,
  "lon": 28.72
}, {
  "lat": -7.51,
  "lon": 29.26
}, {
  "lat": -5.92,
  "lon": 29.79
}, {
  "lat": -4.38,
  "lon": 30.29
}, {
  "lat": -2.87,
  "lon": 30.78
}, {
  "lat": -1.41,
  "lon": 31.26
}, {
  "lat": -57.79,
  "lon": 7.18
}, {
  "lat": -56.42,
  "lon": 8.7
}, {
  "lat": -53.32,
  "lon": 8.76
}, {
  "lat": -54.99,
  "lon": 10.14
}, {
  "lat": -58.27,
  "lon": 13.3
}, {
  "lat": -51.83,
  "lon": 10.12
}, {
  "lat": -53.5,
  "lon": 11.53
}, {
  "lat": -55.16,
  "lon": 13.06
}, {
  "lat": -56.79,
  "lon": 14.73
}, {
  "lat": -58.4,
  "lon": 16.54
}, {
  "lat": -50.28,
  "lon": 11.42
}, {
  "lat": -51.96,
  "lon": 12.86
}, {
  "lat": -53.62,
  "lon": 14.4
}, {
  "lat": -56.87,
  "lon": 17.9
}, {
  "lat": -48.68,
  "lon": 12.67
}, {
  "lat": -50.36,
  "lon": 14.12
}, {
  "lat": -52.02,
  "lon": 15.69
}, {
  "lat": -53.67,
  "lon": 17.37
}, {
  "lat": -56.87,
  "lon": 21.17
}, {
  "lat": -58.42,
  "lon": 23.3
}, {
  "lat": -47.03,
  "lon": 13.87
}, {
  "lat": -48.71,
  "lon": 15.34
}, {
  "lat": -50.37,
  "lon": 16.91
}, {
  "lat": -52.02,
  "lon": 18.6
}, {
  "lat": -53.64,
  "lon": 20.42
}, {
  "lat": -55.23,
  "lon": 22.39
}, {
  "lat": -56.78,
  "lon": 24.5
}, {
  "lat": -58.29,
  "lon": 26.79
}, {
  "lat": -45.34,
  "lon": 15.02
}, {
  "lat": -47.01,
  "lon": 16.5
}, {
  "lat": -48.67,
  "lon": 18.07
}, {
  "lat": -50.32,
  "lon": 19.77
}, {
  "lat": -51.94,
  "lon": 21.58
}, {
  "lat": -53.53,
  "lon": 23.54
}, {
  "lat": -55.09,
  "lon": 25.64
}, {
  "lat": -56.6,
  "lon": 27.89
}, {
  "lat": -58.06,
  "lon": 30.31
}, {
  "lat": -43.6,
  "lon": 16.13
}, {
  "lat": -45.26,
  "lon": 17.6
}, {
  "lat": -46.92,
  "lon": 19.18
}, {
  "lat": -48.57,
  "lon": 20.88
}, {
  "lat": -50.19,
  "lon": 22.69
}, {
  "lat": -51.78,
  "lon": 24.62
}, {
  "lat": -53.34,
  "lon": 26.7
}, {
  "lat": -54.86,
  "lon": 28.92
}, {
  "lat": -56.32,
  "lon": 31.3
}, {
  "lat": -57.72,
  "lon": 33.85
}, {
  "lat": -43.48,
  "lon": 18.67
}, {
  "lat": -45.13,
  "lon": 20.25
}, {
  "lat": -46.77,
  "lon": 21.93
}, {
  "lat": -48.39,
  "lon": 23.73
}, {
  "lat": -49.98,
  "lon": 25.65
}, {
  "lat": -51.54,
  "lon": 27.71
}, {
  "lat": -53.06,
  "lon": 29.9
}, {
  "lat": -54.53,
  "lon": 32.23
}, {
  "lat": -55.94,
  "lon": 34.72
}, {
  "lat": -57.28,
  "lon": 37.37
}, {
  "lat": -40.01,
  "lon": 18.2
}, {
  "lat": -41.65,
  "lon": 19.68
}, {
  "lat": -43.29,
  "lon": 21.26
}, {
  "lat": -44.92,
  "lon": 22.94
}, {
  "lat": -46.54,
  "lon": 24.72
}, {
  "lat": -48.13,
  "lon": 26.63
}, {
  "lat": -49.69,
  "lon": 28.65
}, {
  "lat": -51.21,
  "lon": 30.81
}, {
  "lat": -52.69,
  "lon": 33.1
}, {
  "lat": -54.11,
  "lon": 35.54
}, {
  "lat": -55.46,
  "lon": 38.12
}, {
  "lat": -56.74,
  "lon": 40.84
}, {
  "lat": -39.79,
  "lon": 20.66
}, {
  "lat": -41.42,
  "lon": 22.23
}, {
  "lat": -43.04,
  "lon": 23.89
}, {
  "lat": -44.65,
  "lon": 25.67
}, {
  "lat": -46.24,
  "lon": 27.55
}, {
  "lat": -47.8,
  "lon": 29.55
}, {
  "lat": -49.32,
  "lon": 31.67
}, {
  "lat": -50.8,
  "lon": 33.92
}, {
  "lat": -52.22,
  "lon": 36.3
}, {
  "lat": -53.58,
  "lon": 38.81
}, {
  "lat": -54.88,
  "lon": 41.47
}, {
  "lat": -56.09,
  "lon": 44.25
}, {
  "lat": -37.91,
  "lon": 21.59
}, {
  "lat": -39.52,
  "lon": 23.15
}, {
  "lat": -41.13,
  "lon": 24.81
}, {
  "lat": -42.73,
  "lon": 26.57
}, {
  "lat": -44.31,
  "lon": 28.43
}, {
  "lat": -45.86,
  "lon": 30.4
}, {
  "lat": -47.38,
  "lon": 32.48
}, {
  "lat": -48.86,
  "lon": 34.69
}, {
  "lat": -50.29,
  "lon": 37.02
}, {
  "lat": -51.66,
  "lon": 39.47
}, {
  "lat": -52.97,
  "lon": 42.05
}, {
  "lat": -54.2,
  "lon": 44.75
}, {
  "lat": -55.35,
  "lon": 47.57
}, {
  "lat": -35.99,
  "lon": 22.48
}, {
  "lat": -37.59,
  "lon": 24.04
}, {
  "lat": -39.18,
  "lon": 25.68
}, {
  "lat": -40.77,
  "lon": 27.42
}, {
  "lat": -45.41,
  "lon": 33.25
}, {
  "lat": -46.88,
  "lon": 35.41
}, {
  "lat": -48.32,
  "lon": 37.69
}, {
  "lat": -49.69,
  "lon": 40.08
}, {
  "lat": -51.01,
  "lon": 42.59
}, {
  "lat": -52.26,
  "lon": 45.22
}, {
  "lat": -53.42,
  "lon": 47.95
}, {
  "lat": -54.51,
  "lon": 50.79
}, {
  "lat": -32.5,
  "lon": 21.87
}, {
  "lat": -38.78,
  "lon": 28.23
}, {
  "lat": -40.34,
  "lon": 30.05
}, {
  "lat": -44.87,
  "lon": 36.1
}, {
  "lat": -46.31,
  "lon": 38.32
}, {
  "lat": -47.69,
  "lon": 40.66
}, {
  "lat": -49.01,
  "lon": 43.1
}, {
  "lat": -50.27,
  "lon": 45.65
}, {
  "lat": -51.46,
  "lon": 48.3
}, {
  "lat": -52.56,
  "lon": 51.05
}, {
  "lat": -53.59,
  "lon": 53.89
}, {
  "lat": -30.58,
  "lon": 22.7
}, {
  "lat": -32.12,
  "lon": 24.16
}, {
  "lat": -36.78,
  "lon": 29.01
}, {
  "lat": -38.32,
  "lon": 30.8
}, {
  "lat": -39.85,
  "lon": 32.68
}, {
  "lat": -41.35,
  "lon": 34.66
}, {
  "lat": -44.26,
  "lon": 38.92
}, {
  "lat": -45.65,
  "lon": 41.2
}, {
  "lat": -46.98,
  "lon": 43.58
}, {
  "lat": -48.25,
  "lon": 46.06
}, {
  "lat": -49.45,
  "lon": 48.63
}, {
  "lat": -50.57,
  "lon": 51.29
}, {
  "lat": -51.62,
  "lon": 54.04
}, {
  "lat": -52.58,
  "lon": 56.85
}, {
  "lat": -28.65,
  "lon": 23.5
}, {
  "lat": -30.17,
  "lon": 24.94
}, {
  "lat": -36.28,
  "lon": 31.52
}, {
  "lat": -37.79,
  "lon": 33.37
}, {
  "lat": -39.29,
  "lon": 35.32
}, {
  "lat": -40.75,
  "lon": 37.35
}, {
  "lat": -43.57,
  "lon": 41.71
}, {
  "lat": -44.91,
  "lon": 44.03
}, {
  "lat": -46.19,
  "lon": 46.44
}, {
  "lat": -47.4,
  "lon": 48.94
}, {
  "lat": -48.55,
  "lon": 51.52
}, {
  "lat": -49.62,
  "lon": 54.18
}, {
  "lat": -50.6,
  "lon": 56.9
}, {
  "lat": -51.51,
  "lon": 59.68
}, {
  "lat": -26.73,
  "lon": 24.26
}, {
  "lat": -28.21,
  "lon": 25.7
}, {
  "lat": -29.71,
  "lon": 27.21
}, {
  "lat": -31.21,
  "lon": 28.79
}, {
  "lat": -34.23,
  "lon": 32.2
}, {
  "lat": -35.73,
  "lon": 34.02
}, {
  "lat": -37.21,
  "lon": 35.93
}, {
  "lat": -38.66,
  "lon": 37.93
}, {
  "lat": -40.09,
  "lon": 40.02
}, {
  "lat": -41.48,
  "lon": 42.19
}, {
  "lat": -42.82,
  "lon": 44.45
}, {
  "lat": -44.1,
  "lon": 46.8
}, {
  "lat": -45.33,
  "lon": 49.23
}, {
  "lat": -46.49,
  "lon": 51.73
}, {
  "lat": -47.58,
  "lon": 54.31
}, {
  "lat": -48.59,
  "lon": 56.94
}, {
  "lat": -49.52,
  "lon": 59.63
}, {
  "lat": -50.37,
  "lon": 62.37
}, {
  "lat": -24.82,
  "lon": 25
}, {
  "lat": -26.26,
  "lon": 26.43
}, {
  "lat": -27.73,
  "lon": 27.92
}, {
  "lat": -29.2,
  "lon": 29.49
}, {
  "lat": -30.69,
  "lon": 31.13
}, {
  "lat": -35.11,
  "lon": 36.52
}, {
  "lat": -36.56,
  "lon": 38.48
}, {
  "lat": -37.97,
  "lon": 40.52
}, {
  "lat": -39.36,
  "lon": 42.65
}, {
  "lat": -40.7,
  "lon": 44.85
}, {
  "lat": -41.99,
  "lon": 47.14
}, {
  "lat": -44.4,
  "lon": 51.93
}, {
  "lat": -45.51,
  "lon": 54.43
}, {
  "lat": -46.54,
  "lon": 56.99
}, {
  "lat": -47.5,
  "lon": 59.59
}, {
  "lat": -48.38,
  "lon": 62.24
}, {
  "lat": -49.19,
  "lon": 64.91
}, {
  "lat": -22.91,
  "lon": 25.71
}, {
  "lat": -24.32,
  "lon": 27.12
}, {
  "lat": -25.75,
  "lon": 28.6
}, {
  "lat": -27.2,
  "lon": 30.15
}, {
  "lat": -28.65,
  "lon": 31.77
}, {
  "lat": -30.11,
  "lon": 33.47
}, {
  "lat": -31.57,
  "lon": 35.24
}, {
  "lat": -33.01,
  "lon": 37.08
}, {
  "lat": -34.44,
  "lon": 39
}, {
  "lat": -35.85,
  "lon": 41
}, {
  "lat": -37.23,
  "lon": 43.08
}, {
  "lat": -38.56,
  "lon": 45.23
}, {
  "lat": -39.86,
  "lon": 47.46
}, {
  "lat": -41.1,
  "lon": 49.76
}, {
  "lat": -42.29,
  "lon": 52.12
}, {
  "lat": -43.41,
  "lon": 54.54
}, {
  "lat": -44.47,
  "lon": 57.02
}, {
  "lat": -45.45,
  "lon": 59.55
}, {
  "lat": -46.36,
  "lon": 62.12
}, {
  "lat": -47.2,
  "lon": 64.71
}, {
  "lat": -47.95,
  "lon": 67.32
}, {
  "lat": -21.02,
  "lon": 26.39
}, {
  "lat": -22.39,
  "lon": 27.79
}, {
  "lat": -23.79,
  "lon": 29.26
}, {
  "lat": -25.2,
  "lon": 30.79
}, {
  "lat": -26.63,
  "lon": 32.39
}, {
  "lat": -28.06,
  "lon": 34.06
}, {
  "lat": -29.49,
  "lon": 35.8
}, {
  "lat": -30.91,
  "lon": 37.61
}, {
  "lat": -32.33,
  "lon": 39.5
}, {
  "lat": -33.72,
  "lon": 41.46
}, {
  "lat": -35.09,
  "lon": 43.49
}, {
  "lat": -36.42,
  "lon": 45.59
}, {
  "lat": -37.71,
  "lon": 47.76
}, {
  "lat": -40.16,
  "lon": 52.3
}, {
  "lat": -41.29,
  "lon": 54.65
}, {
  "lat": -42.37,
  "lon": 57.06
}, {
  "lat": -43.38,
  "lon": 59.51
}, {
  "lat": -44.31,
  "lon": 62
}, {
  "lat": -45.18,
  "lon": 64.52
}, {
  "lat": -45.97,
  "lon": 67.05
}, {
  "lat": -46.69,
  "lon": 69.59
}, {
  "lat": -19.15,
  "lon": 27.05
}, {
  "lat": -20.49,
  "lon": 28.44
}, {
  "lat": -21.85,
  "lon": 29.89
}, {
  "lat": -23.22,
  "lon": 31.4
}, {
  "lat": -24.61,
  "lon": 32.98
}, {
  "lat": -26.01,
  "lon": 34.63
}, {
  "lat": -27.42,
  "lon": 36.34
}, {
  "lat": -28.82,
  "lon": 38.12
}, {
  "lat": -30.21,
  "lon": 39.97
}, {
  "lat": -31.59,
  "lon": 41.89
}, {
  "lat": -32.95,
  "lon": 43.87
}, {
  "lat": -34.27,
  "lon": 45.93
}, {
  "lat": -35.56,
  "lon": 48.05
}, {
  "lat": -36.81,
  "lon": 50.23
}, {
  "lat": -39.16,
  "lon": 54.76
}, {
  "lat": -40.25,
  "lon": 57.1
}, {
  "lat": -41.28,
  "lon": 59.48
}, {
  "lat": -42.24,
  "lon": 61.89
}, {
  "lat": -43.14,
  "lon": 64.33
}, {
  "lat": -43.96,
  "lon": 66.79
}, {
  "lat": -44.71,
  "lon": 69.26
}, {
  "lat": -45.39,
  "lon": 71.73
}, {
  "lat": -17.3,
  "lon": 27.68
}, {
  "lat": -18.6,
  "lon": 29.06
}, {
  "lat": -19.92,
  "lon": 30.5
}, {
  "lat": -21.26,
  "lon": 31.99
}, {
  "lat": -22.62,
  "lon": 33.55
}, {
  "lat": -23.99,
  "lon": 35.17
}, {
  "lat": -25.36,
  "lon": 36.85
}, {
  "lat": -26.74,
  "lon": 38.6
}, {
  "lat": -28.11,
  "lon": 40.42
}, {
  "lat": -29.47,
  "lon": 42.3
}, {
  "lat": -30.81,
  "lon": 44.24
}, {
  "lat": -32.13,
  "lon": 46.25
}, {
  "lat": -33.41,
  "lon": 48.32
}, {
  "lat": -34.66,
  "lon": 50.44
}, {
  "lat": -35.87,
  "lon": 52.62
}, {
  "lat": -37.02,
  "lon": 54.85
}, {
  "lat": -38.13,
  "lon": 57.13
}, {
  "lat": -39.17,
  "lon": 59.44
}, {
  "lat": -40.16,
  "lon": 61.79
}, {
  "lat": -41.08,
  "lon": 64.16
}, {
  "lat": -41.93,
  "lon": 66.55
}, {
  "lat": -42.71,
  "lon": 68.95
}, {
  "lat": -43.43,
  "lon": 71.35
}, {
  "lat": -44.08,
  "lon": 73.74
}, {
  "lat": -15.49,
  "lon": 28.29
}, {
  "lat": -16.75,
  "lon": 29.66
}, {
  "lat": -18.03,
  "lon": 31.08
}, {
  "lat": -19.33,
  "lon": 32.56
}, {
  "lat": -20.65,
  "lon": 34.09
}, {
  "lat": -21.99,
  "lon": 35.69
}, {
  "lat": -24.68,
  "lon": 39.06
}, {
  "lat": -26.02,
  "lon": 40.85
}, {
  "lat": -27.36,
  "lon": 42.69
}, {
  "lat": -28.69,
  "lon": 44.59
}, {
  "lat": -29.99,
  "lon": 46.55
}, {
  "lat": -31.27,
  "lon": 48.57
}, {
  "lat": -32.51,
  "lon": 50.65
}, {
  "lat": -33.72,
  "lon": 52.77
}, {
  "lat": -34.88,
  "lon": 54.95
}, {
  "lat": -35.99,
  "lon": 57.16
}, {
  "lat": -37.06,
  "lon": 59.41
}, {
  "lat": -38.06,
  "lon": 61.7
}, {
  "lat": -39,
  "lon": 64
}, {
  "lat": -39.88,
  "lon": 66.33
}, {
  "lat": -40.7,
  "lon": 68.66
}, {
  "lat": -41.45,
  "lon": 70.99
}, {
  "lat": -42.13,
  "lon": 73.32
}, {
  "lat": -42.76,
  "lon": 75.63
}, {
  "lat": -13.7,
  "lon": 28.88
}, {
  "lat": -14.92,
  "lon": 30.23
}, {
  "lat": -16.16,
  "lon": 31.64
}, {
  "lat": -17.43,
  "lon": 33.1
}, {
  "lat": -18.71,
  "lon": 34.61
}, {
  "lat": -20.01,
  "lon": 36.19
}, {
  "lat": -22.64,
  "lon": 39.51
}, {
  "lat": -23.96,
  "lon": 41.25
}, {
  "lat": -25.27,
  "lon": 43.06
}, {
  "lat": -26.58,
  "lon": 44.92
}, {
  "lat": -27.87,
  "lon": 46.84
}, {
  "lat": -30.37,
  "lon": 50.84
}, {
  "lat": -31.58,
  "lon": 52.91
}, {
  "lat": -32.74,
  "lon": 55.03
}, {
  "lat": -33.86,
  "lon": 57.19
}, {
  "lat": -34.93,
  "lon": 59.38
}, {
  "lat": -35.95,
  "lon": 61.6
}, {
  "lat": -36.92,
  "lon": 63.85
}, {
  "lat": -37.82,
  "lon": 66.11
}, {
  "lat": -38.67,
  "lon": 68.38
}, {
  "lat": -39.45,
  "lon": 70.65
}, {
  "lat": -40.17,
  "lon": 72.92
}, {
  "lat": -40.83,
  "lon": 75.17
}, {
  "lat": -41.43,
  "lon": 77.41
}, {
  "lat": -11.96,
  "lon": 29.45
}, {
  "lat": -13.13,
  "lon": 30.79
}, {
  "lat": -14.33,
  "lon": 32.18
}, {
  "lat": -15.56,
  "lon": 33.62
}, {
  "lat": -16.81,
  "lon": 35.11
}, {
  "lat": -18.07,
  "lon": 36.66
}, {
  "lat": -20.63,
  "lon": 39.93
}, {
  "lat": -21.92,
  "lon": 41.64
}, {
  "lat": -23.21,
  "lon": 43.42
}, {
  "lat": -24.49,
  "lon": 45.24
}, {
  "lat": -25.76,
  "lon": 47.12
}, {
  "lat": -27.02,
  "lon": 49.05
}, {
  "lat": -28.24,
  "lon": 51.03
}, {
  "lat": -29.44,
  "lon": 53.05
}, {
  "lat": -30.61,
  "lon": 55.12
}, {
  "lat": -31.74,
  "lon": 57.22
}, {
  "lat": -32.82,
  "lon": 59.35
}, {
  "lat": -33.85,
  "lon": 61.52
}, {
  "lat": -34.83,
  "lon": 63.7
}, {
  "lat": -35.76,
  "lon": 65.91
}, {
  "lat": -36.63,
  "lon": 68.12
}, {
  "lat": -37.44,
  "lon": 70.33
}, {
  "lat": -38.19,
  "lon": 72.54
}, {
  "lat": -38.89,
  "lon": 74.74
}, {
  "lat": -39.52,
  "lon": 76.92
}, {
  "lat": -40.1,
  "lon": 79.08
}, {
  "lat": -10.25,
  "lon": 30
}, {
  "lat": -11.38,
  "lon": 31.32
}, {
  "lat": -12.54,
  "lon": 32.7
}, {
  "lat": -13.73,
  "lon": 34.12
}, {
  "lat": -14.94,
  "lon": 35.59
}, {
  "lat": -16.16,
  "lon": 37.12
}, {
  "lat": -17.4,
  "lon": 38.7
}, {
  "lat": -19.92,
  "lon": 42.02
}, {
  "lat": -21.18,
  "lon": 43.76
}, {
  "lat": -22.44,
  "lon": 45.54
}, {
  "lat": -23.69,
  "lon": 47.38
}, {
  "lat": -24.92,
  "lon": 49.27
}, {
  "lat": -27.33,
  "lon": 53.18
}, {
  "lat": -28.49,
  "lon": 55.19
}, {
  "lat": -29.62,
  "lon": 57.24
}, {
  "lat": -30.71,
  "lon": 59.33
}, {
  "lat": -31.75,
  "lon": 61.44
}, {
  "lat": -32.75,
  "lon": 63.57
}, {
  "lat": -33.69,
  "lon": 65.71
}, {
  "lat": -34.59,
  "lon": 67.87
}, {
  "lat": -35.43,
  "lon": 70.02
}, {
  "lat": -36.21,
  "lon": 72.18
}, {
  "lat": -36.94,
  "lon": 74.33
}, {
  "lat": -37.61,
  "lon": 76.46
}, {
  "lat": -38.22,
  "lon": 78.57
}, {
  "lat": -38.78,
  "lon": 80.66
}, {
  "lat": -8.58,
  "lon": 30.53
}, {
  "lat": -9.67,
  "lon": 31.84
}, {
  "lat": -10.79,
  "lon": 33.2
}, {
  "lat": -11.94,
  "lon": 34.6
}, {
  "lat": -13.11,
  "lon": 36.06
}, {
  "lat": -14.3,
  "lon": 37.56
}, {
  "lat": -15.5,
  "lon": 39.12
}, {
  "lat": -17.95,
  "lon": 42.38
}, {
  "lat": -19.18,
  "lon": 44.08
}, {
  "lat": -20.41,
  "lon": 45.83
}, {
  "lat": -21.64,
  "lon": 47.63
}, {
  "lat": -22.86,
  "lon": 49.48
}, {
  "lat": -24.06,
  "lon": 51.37
}, {
  "lat": -26.4,
  "lon": 55.27
}, {
  "lat": -27.52,
  "lon": 57.27
}, {
  "lat": -28.61,
  "lon": 59.3
}, {
  "lat": -29.66,
  "lon": 61.36
}, {
  "lat": -30.67,
  "lon": 63.43
}, {
  "lat": -31.63,
  "lon": 65.53
}, {
  "lat": -32.55,
  "lon": 67.63
}, {
  "lat": -33.41,
  "lon": 69.73
}, {
  "lat": -34.22,
  "lon": 71.84
}, {
  "lat": -34.98,
  "lon": 73.93
}, {
  "lat": -35.68,
  "lon": 76.02
}, {
  "lat": -36.33,
  "lon": 78.08
}, {
  "lat": -36.93,
  "lon": 80.12
}, {
  "lat": -37.48,
  "lon": 82.14
}, {
  "lat": -6.95,
  "lon": 31.04
}, {
  "lat": -8,
  "lon": 32.34
}, {
  "lat": -9.08,
  "lon": 33.68
}, {
  "lat": -10.19,
  "lon": 35.07
}, {
  "lat": -11.32,
  "lon": 36.5
}, {
  "lat": -12.47,
  "lon": 37.98
}, {
  "lat": -13.64,
  "lon": 39.51
}, {
  "lat": -16.02,
  "lon": 42.72
}, {
  "lat": -17.22,
  "lon": 44.39
}, {
  "lat": -18.42,
  "lon": 46.11
}, {
  "lat": -19.63,
  "lon": 47.87
}, {
  "lat": -20.82,
  "lon": 49.68
}, {
  "lat": -22.01,
  "lon": 51.53
}, {
  "lat": -23.18,
  "lon": 53.42
}, {
  "lat": -24.33,
  "lon": 55.34
}, {
  "lat": -25.45,
  "lon": 57.29
}, {
  "lat": -26.54,
  "lon": 59.28
}, {
  "lat": -27.59,
  "lon": 61.28
}, {
  "lat": -28.61,
  "lon": 63.31
}, {
  "lat": -29.59,
  "lon": 65.35
}, {
  "lat": -30.52,
  "lon": 67.4
}, {
  "lat": -31.4,
  "lon": 69.46
}, {
  "lat": -32.23,
  "lon": 71.51
}, {
  "lat": -33.02,
  "lon": 73.56
}, {
  "lat": -33.75,
  "lon": 75.59
}, {
  "lat": -34.43,
  "lon": 77.61
}, {
  "lat": -35.07,
  "lon": 79.61
}, {
  "lat": -35.65,
  "lon": 81.59
}, {
  "lat": -36.19,
  "lon": 83.53
}, {
  "lat": -5.36,
  "lon": 31.53
}, {
  "lat": -6.38,
  "lon": 32.82
}, {
  "lat": -7.42,
  "lon": 34.14
}, {
  "lat": -8.49,
  "lon": 35.51
}, {
  "lat": -9.58,
  "lon": 36.93
}, {
  "lat": -10.69,
  "lon": 38.39
}, {
  "lat": -11.82,
  "lon": 39.9
}, {
  "lat": -12.97,
  "lon": 41.45
}, {
  "lat": -14.13,
  "lon": 43.05
}, {
  "lat": -15.3,
  "lon": 44.69
}, {
  "lat": -16.48,
  "lon": 46.38
}, {
  "lat": -17.66,
  "lon": 48.1
}, {
  "lat": -18.83,
  "lon": 49.87
}, {
  "lat": -20,
  "lon": 51.68
}, {
  "lat": -21.15,
  "lon": 53.53
}, {
  "lat": -22.29,
  "lon": 55.41
}, {
  "lat": -23.4,
  "lon": 57.32
}, {
  "lat": -25.54,
  "lon": 61.21
}, {
  "lat": -26.57,
  "lon": 63.19
}, {
  "lat": -27.55,
  "lon": 65.18
}, {
  "lat": -28.5,
  "lon": 67.19
}, {
  "lat": -29.4,
  "lon": 69.19
}, {
  "lat": -30.25,
  "lon": 71.2
}, {
  "lat": -31.06,
  "lon": 73.2
}, {
  "lat": -31.82,
  "lon": 75.19
}, {
  "lat": -32.53,
  "lon": 77.17
}, {
  "lat": -33.2,
  "lon": 79.13
}, {
  "lat": -33.82,
  "lon": 81.06
}, {
  "lat": -34.39,
  "lon": 82.97
}, {
  "lat": -34.91,
  "lon": 84.84
}, {
  "lat": -3.82,
  "lon": 32.01
}, {
  "lat": -4.8,
  "lon": 33.28
}, {
  "lat": -5.8,
  "lon": 34.59
}, {
  "lat": -6.83,
  "lon": 35.94
}, {
  "lat": -7.88,
  "lon": 37.34
}, {
  "lat": -8.96,
  "lon": 38.78
}, {
  "lat": -10.05,
  "lon": 40.26
}, {
  "lat": -11.16,
  "lon": 41.79
}, {
  "lat": -12.29,
  "lon": 43.36
}, {
  "lat": -13.43,
  "lon": 44.97
}, {
  "lat": -14.58,
  "lon": 46.63
}, {
  "lat": -15.73,
  "lon": 48.32
}, {
  "lat": -16.88,
  "lon": 50.06
}, {
  "lat": -18.02,
  "lon": 51.83
}, {
  "lat": -19.16,
  "lon": 53.64
}, {
  "lat": -20.28,
  "lon": 55.47
}, {
  "lat": -21.38,
  "lon": 57.34
}, {
  "lat": -22.47,
  "lon": 59.23
}, {
  "lat": -24.55,
  "lon": 63.08
}, {
  "lat": -25.54,
  "lon": 65.02
}, {
  "lat": -26.49,
  "lon": 66.98
}, {
  "lat": -27.41,
  "lon": 68.94
}, {
  "lat": -28.28,
  "lon": 70.9
}, {
  "lat": -33.15,
  "lon": 84.27
}, {
  "lat": -33.67,
  "lon": 86.08
}, {
  "lat": -2.33,
  "lon": 32.47
}, {
  "lat": -3.26,
  "lon": 33.73
}, {
  "lat": -4.23,
  "lon": 35.02
}, {
  "lat": -5.22,
  "lon": 36.36
}, {
  "lat": -6.23,
  "lon": 37.74
}, {
  "lat": -7.27,
  "lon": 39.16
}, {
  "lat": -8.33,
  "lon": 40.62
}, {
  "lat": -9.41,
  "lon": 42.12
}, {
  "lat": -10.5,
  "lon": 43.66
}, {
  "lat": -12.72,
  "lon": 46.87
}, {
  "lat": -13.84,
  "lon": 48.54
}, {
  "lat": -14.97,
  "lon": 50.23
}, {
  "lat": -16.09,
  "lon": 51.97
}, {
  "lat": -17.21,
  "lon": 53.74
}, {
  "lat": -18.31,
  "lon": 55.53
}, {
  "lat": -19.41,
  "lon": 57.36
}, {
  "lat": -20.48,
  "lon": 59.21
}, {
  "lat": -0.87,
  "lon": 32.92
}, {
  "lat": -1.78,
  "lon": 34.16
}, {
  "lat": -2.7,
  "lon": 35.44
}, {
  "lat": -3.66,
  "lon": 36.76
}, {
  "lat": -4.63,
  "lon": 38.12
}, {
  "lat": -5.63,
  "lon": 39.52
}, {
  "lat": -6.66,
  "lon": 40.96
}, {
  "lat": -7.7,
  "lon": 42.44
}, {
  "lat": -8.76,
  "lon": 43.96
}, {
  "lat": -9.83,
  "lon": 45.51
}, {
  "lat": -10.91,
  "lon": 47.11
}, {
  "lat": -11.14,
  "lon": 50.4
}, {
  "lat": -10.05,
  "lon": 48.74
}, {
  "lat": -9.15,
  "lon": 50.4
}, {
  "lat": -8.96,
  "lon": 47.11
}, {
  "lat": -8.07,
  "lon": 48.74
}, {
  "lat": -7.89,
  "lon": 45.51
}, {
  "lat": -6.99,
  "lon": 47.11
}, {
  "lat": -6.07,
  "lon": 48.74
}, {
  "lat": -6.83,
  "lon": 43.96
}, {
  "lat": -5.93,
  "lon": 45.51
}, {
  "lat": -5.01,
  "lon": 47.11
}, {
  "lat": -5.79,
  "lon": 42.44
}, {
  "lat": -4.89,
  "lon": 43.96
}, {
  "lat": -3.96,
  "lon": 45.51
}, {
  "lat": -3.01,
  "lon": 47.11
}, {
  "lat": -4.76,
  "lon": 40.96
}, {
  "lat": -3.87,
  "lon": 42.44
}, {
  "lat": -2.94,
  "lon": 43.96
}, {
  "lat": -1.98,
  "lon": 45.51
}, {
  "lat": -3.76,
  "lon": 39.52
}, {
  "lat": -2.86,
  "lon": 40.96
}, {
  "lat": -1.94,
  "lon": 42.44
}, {
  "lat": -0.98,
  "lon": 43.96
}, {
  "lat": -2.78,
  "lon": 38.12
}, {
  "lat": -1.88,
  "lon": 39.52
}, {
  "lat": -0.95,
  "lon": 40.96
}, {
  "lat": 0,
  "lon": 42.44
}, {
  "lat": -1.83,
  "lon": 36.76
}, {
  "lat": -0.93,
  "lon": 38.12
}, {
  "lat": 0,
  "lon": 39.52
}, {
  "lat": 0.95,
  "lon": 40.96
}, {
  "lat": -0.9,
  "lon": 35.44
}, {
  "lat": 0,
  "lon": 36.76
}, {
  "lat": 0.93,
  "lon": 38.12
}, {
  "lat": 1.88,
  "lon": 39.52
}, {
  "lat": 2.86,
  "lon": 40.96
}, {
  "lat": 0,
  "lon": 34.16
}, {
  "lat": 0.9,
  "lon": 35.44
}, {
  "lat": 1.83,
  "lon": 36.76
}, {
  "lat": 2.78,
  "lon": 38.12
}, {
  "lat": 3.76,
  "lon": 39.52
}, {
  "lat": 0.87,
  "lon": 32.92
}, {
  "lat": 1.78,
  "lon": 34.16
}, {
  "lat": 2.7,
  "lon": 35.44
}, {
  "lat": 3.66,
  "lon": 36.76
}, {
  "lat": 4.63,
  "lon": 38.12
}, {
  "lat": 5.63,
  "lon": 39.52
}, {
  "lat": 14.97,
  "lon": 50.23
}, {
  "lat": 16.88,
  "lon": 50.06
}, {
  "lat": 18.83,
  "lon": 49.87
}, {
  "lat": 13.84,
  "lon": 48.54
}, {
  "lat": 15.73,
  "lon": 48.32
}, {
  "lat": 17.66,
  "lon": 48.1
}, {
  "lat": 19.63,
  "lon": 47.87
}, {
  "lat": 21.64,
  "lon": 47.63
}, {
  "lat": 23.69,
  "lon": 47.38
}, {
  "lat": 25.76,
  "lon": 47.12
}, {
  "lat": 16.48,
  "lon": 46.38
}, {
  "lat": 18.42,
  "lon": 46.11
}, {
  "lat": 20.41,
  "lon": 45.83
}, {
  "lat": 22.44,
  "lon": 45.54
}, {
  "lat": 24.49,
  "lon": 45.24
}, {
  "lat": 17.22,
  "lon": 44.39
}, {
  "lat": 19.18,
  "lon": 44.08
}, {
  "lat": 21.18,
  "lon": 43.76
}, {
  "lat": 23.21,
  "lon": 43.42
}, {
  "lat": 14.82,
  "lon": 41.09
}, {
  "lat": 11.82,
  "lon": 39.9
}, {
  "lat": 13.64,
  "lon": 39.51
}, {
  "lat": 15.5,
  "lon": 39.12
}, {
  "lat": 17.4,
  "lon": 38.7
}, {
  "lat": 7.27,
  "lon": 39.16
}, {
  "lat": 8.96,
  "lon": 38.78
}, {
  "lat": 10.69,
  "lon": 38.39
}, {
  "lat": 12.47,
  "lon": 37.98
}, {
  "lat": 14.3,
  "lon": 37.56
}, {
  "lat": 16.16,
  "lon": 37.12
}, {
  "lat": 18.07,
  "lon": 36.66
}, {
  "lat": 21.99,
  "lon": 35.69
}, {
  "lat": 23.99,
  "lon": 35.17
}, {
  "lat": 6.23,
  "lon": 37.74
}, {
  "lat": 7.88,
  "lon": 37.34
}, {
  "lat": 9.58,
  "lon": 36.93
}, {
  "lat": 11.32,
  "lon": 36.5
}, {
  "lat": 13.11,
  "lon": 36.06
}, {
  "lat": 14.94,
  "lon": 35.59
}, {
  "lat": 16.81,
  "lon": 35.11
}, {
  "lat": 18.71,
  "lon": 34.61
}, {
  "lat": 20.65,
  "lon": 34.09
}, {
  "lat": 22.62,
  "lon": 33.55
}, {
  "lat": 24.61,
  "lon": 32.98
}, {
  "lat": 26.63,
  "lon": 32.39
}, {
  "lat": 28.65,
  "lon": 31.77
}, {
  "lat": 30.69,
  "lon": 31.13
}, {
  "lat": 5.22,
  "lon": 36.36
}, {
  "lat": 6.83,
  "lon": 35.94
}, {
  "lat": 8.49,
  "lon": 35.51
}, {
  "lat": 10.19,
  "lon": 35.07
}, {
  "lat": 11.94,
  "lon": 34.6
}, {
  "lat": 13.73,
  "lon": 34.12
}, {
  "lat": 15.56,
  "lon": 33.62
}, {
  "lat": 17.43,
  "lon": 33.1
}, {
  "lat": 19.33,
  "lon": 32.56
}, {
  "lat": 21.26,
  "lon": 31.99
}, {
  "lat": 23.22,
  "lon": 31.4
}, {
  "lat": 25.2,
  "lon": 30.79
}, {
  "lat": 27.2,
  "lon": 30.15
}, {
  "lat": 29.2,
  "lon": 29.49
}, {
  "lat": 31.21,
  "lon": 28.79
}, {
  "lat": 33.22,
  "lon": 28.07
}, {
  "lat": 4.23,
  "lon": 35.02
}, {
  "lat": 5.8,
  "lon": 34.59
}, {
  "lat": 7.42,
  "lon": 34.14
}, {
  "lat": 9.08,
  "lon": 33.68
}, {
  "lat": 10.79,
  "lon": 33.2
}, {
  "lat": 12.54,
  "lon": 32.7
}, {
  "lat": 14.33,
  "lon": 32.18
}, {
  "lat": 16.16,
  "lon": 31.64
}, {
  "lat": 18.03,
  "lon": 31.08
}, {
  "lat": 19.92,
  "lon": 30.5
}, {
  "lat": 21.85,
  "lon": 29.89
}, {
  "lat": 23.79,
  "lon": 29.26
}, {
  "lat": 25.75,
  "lon": 28.6
}, {
  "lat": 27.73,
  "lon": 27.92
}, {
  "lat": 29.71,
  "lon": 27.21
}, {
  "lat": 31.69,
  "lon": 26.47
}, {
  "lat": 33.67,
  "lon": 25.69
}, {
  "lat": 3.26,
  "lon": 33.73
}, {
  "lat": 4.8,
  "lon": 33.28
}, {
  "lat": 6.38,
  "lon": 32.82
}, {
  "lat": 8,
  "lon": 32.34
}, {
  "lat": 9.67,
  "lon": 31.84
}, {
  "lat": 11.38,
  "lon": 31.32
}, {
  "lat": 13.13,
  "lon": 30.79
}, {
  "lat": 14.92,
  "lon": 30.23
}, {
  "lat": 16.75,
  "lon": 29.66
}, {
  "lat": 18.6,
  "lon": 29.06
}, {
  "lat": 20.49,
  "lon": 28.44
}, {
  "lat": 22.39,
  "lon": 27.79
}, {
  "lat": 24.32,
  "lon": 27.12
}, {
  "lat": 26.26,
  "lon": 26.43
}, {
  "lat": 28.21,
  "lon": 25.7
}, {
  "lat": 30.17,
  "lon": 24.94
}, {
  "lat": 32.12,
  "lon": 24.16
}, {
  "lat": 34.06,
  "lon": 23.34
}, {
  "lat": 2.33,
  "lon": 32.47
}, {
  "lat": 3.82,
  "lon": 32.01
}, {
  "lat": 5.36,
  "lon": 31.53
}, {
  "lat": 6.95,
  "lon": 31.04
}, {
  "lat": 8.58,
  "lon": 30.53
}, {
  "lat": 10.25,
  "lon": 30
}, {
  "lat": 11.96,
  "lon": 29.45
}, {
  "lat": 13.7,
  "lon": 28.88
}, {
  "lat": 15.49,
  "lon": 28.29
}, {
  "lat": 17.3,
  "lon": 27.68
}, {
  "lat": 19.15,
  "lon": 27.05
}, {
  "lat": 21.02,
  "lon": 26.39
}, {
  "lat": 22.91,
  "lon": 25.71
}, {
  "lat": 24.82,
  "lon": 25
}, {
  "lat": 26.73,
  "lon": 24.26
}, {
  "lat": 28.65,
  "lon": 23.5
}, {
  "lat": 30.58,
  "lon": 22.7
}, {
  "lat": 32.5,
  "lon": 21.87
}, {
  "lat": 34.4,
  "lon": 21.01
}, {
  "lat": 1.41,
  "lon": 31.26
}, {
  "lat": 2.87,
  "lon": 30.78
}, {
  "lat": 4.38,
  "lon": 30.29
}, {
  "lat": 5.92,
  "lon": 29.79
}, {
  "lat": 7.51,
  "lon": 29.26
}, {
  "lat": 9.14,
  "lon": 28.72
}, {
  "lat": 10.81,
  "lon": 28.16
}, {
  "lat": 12.52,
  "lon": 27.58
}, {
  "lat": 14.26,
  "lon": 26.98
}, {
  "lat": 16.03,
  "lon": 26.36
}, {
  "lat": 17.84,
  "lon": 25.72
}, {
  "lat": 19.67,
  "lon": 25.05
}, {
  "lat": 21.52,
  "lon": 24.36
}, {
  "lat": 23.39,
  "lon": 23.64
}, {
  "lat": 25.27,
  "lon": 22.89
}, {
  "lat": 27.16,
  "lon": 22.12
}, {
  "lat": 29.05,
  "lon": 21.32
}, {
  "lat": 30.94,
  "lon": 20.48
}, {
  "lat": 32.83,
  "lon": 19.62
}, {
  "lat": 34.7,
  "lon": 18.72
}, {
  "lat": -58.4,
  "lon": 163.46
}, {
  "lat": -58.46,
  "lon": 160.12
}, {
  "lat": -56.87,
  "lon": 162.1
}, {
  "lat": -56.87,
  "lon": 158.83
}, {
  "lat": -55.29,
  "lon": 160.8
}, {
  "lat": -55.23,
  "lon": 157.61
}, {
  "lat": -53.64,
  "lon": 159.58
}, {
  "lat": -53.53,
  "lon": 156.46
}, {
  "lat": -51.94,
  "lon": 158.42
}, {
  "lat": -56.74,
  "lon": 139.16
}, {
  "lat": -56.09,
  "lon": 135.75
}, {
  "lat": -54.88,
  "lon": 138.53
}, {
  "lat": -53.58,
  "lon": 141.19
}, {
  "lat": -52.22,
  "lon": 143.7
}, {
  "lat": -55.35,
  "lon": 132.43
}, {
  "lat": -54.2,
  "lon": 135.25
}, {
  "lat": -52.97,
  "lon": 137.95
}, {
  "lat": -51.66,
  "lon": 140.53
}, {
  "lat": -50.29,
  "lon": 142.98
}, {
  "lat": -54.51,
  "lon": 129.21
}, {
  "lat": -53.42,
  "lon": 132.05
}, {
  "lat": -52.26,
  "lon": 134.78
}, {
  "lat": -51.01,
  "lon": 137.41
}, {
  "lat": -49.69,
  "lon": 139.92
}, {
  "lat": -48.32,
  "lon": 142.31
}, {
  "lat": -53.59,
  "lon": 126.11
}, {
  "lat": -52.56,
  "lon": 128.95
}, {
  "lat": -51.46,
  "lon": 131.7
}, {
  "lat": -50.27,
  "lon": 134.35
}, {
  "lat": -49.01,
  "lon": 136.9
}, {
  "lat": -47.69,
  "lon": 139.34
}, {
  "lat": -46.31,
  "lon": 141.68
}, {
  "lat": -43.39,
  "lon": 146.02
}, {
  "lat": -52.58,
  "lon": 123.15
}, {
  "lat": -51.62,
  "lon": 125.96
}, {
  "lat": -50.57,
  "lon": 128.71
}, {
  "lat": -49.45,
  "lon": 131.37
}, {
  "lat": -48.25,
  "lon": 133.94
}, {
  "lat": -46.98,
  "lon": 136.42
}, {
  "lat": -42.83,
  "lon": 143.26
}, {
  "lat": -51.51,
  "lon": 120.32
}, {
  "lat": -50.6,
  "lon": 123.1
}, {
  "lat": -49.62,
  "lon": 125.82
}, {
  "lat": -48.55,
  "lon": 128.48
}, {
  "lat": -47.4,
  "lon": 131.06
}, {
  "lat": -46.19,
  "lon": 133.56
}, {
  "lat": -44.91,
  "lon": 135.97
}, {
  "lat": -42.19,
  "lon": 140.51
}, {
  "lat": -50.37,
  "lon": 117.63
}, {
  "lat": -49.52,
  "lon": 120.37
}, {
  "lat": -48.59,
  "lon": 123.06
}, {
  "lat": -47.58,
  "lon": 125.69
}, {
  "lat": -46.49,
  "lon": 128.27
}, {
  "lat": -45.33,
  "lon": 130.77
}, {
  "lat": -44.1,
  "lon": 133.2
}, {
  "lat": -42.82,
  "lon": 135.55
}, {
  "lat": -40.09,
  "lon": 139.98
}, {
  "lat": -38.66,
  "lon": 142.07
}, {
  "lat": -49.19,
  "lon": 115.09
}, {
  "lat": -48.38,
  "lon": 117.76
}, {
  "lat": -47.5,
  "lon": 120.41
}, {
  "lat": -46.54,
  "lon": 123.01
}, {
  "lat": -45.51,
  "lon": 125.57
}, {
  "lat": -44.4,
  "lon": 128.07
}, {
  "lat": -43.23,
  "lon": 130.5
}, {
  "lat": -41.99,
  "lon": 132.86
}, {
  "lat": -37.97,
  "lon": 139.48
}, {
  "lat": -36.56,
  "lon": 141.52
}, {
  "lat": -47.95,
  "lon": 112.68
}, {
  "lat": -47.2,
  "lon": 115.29
}, {
  "lat": -46.36,
  "lon": 117.88
}, {
  "lat": -45.45,
  "lon": 120.45
}, {
  "lat": -44.47,
  "lon": 122.98
}, {
  "lat": -43.41,
  "lon": 125.46
}, {
  "lat": -42.29,
  "lon": 127.88
}, {
  "lat": -41.1,
  "lon": 130.24
}, {
  "lat": -37.23,
  "lon": 136.92
}, {
  "lat": -35.85,
  "lon": 139
}, {
  "lat": -46.69,
  "lon": 110.41
}, {
  "lat": -45.97,
  "lon": 112.95
}, {
  "lat": -45.18,
  "lon": 115.48
}, {
  "lat": -44.31,
  "lon": 118
}, {
  "lat": -43.38,
  "lon": 120.49
}, {
  "lat": -42.37,
  "lon": 122.94
}, {
  "lat": -41.29,
  "lon": 125.35
}, {
  "lat": -40.16,
  "lon": 127.7
}, {
  "lat": -35.09,
  "lon": 136.51
}, {
  "lat": -33.72,
  "lon": 138.54
}, {
  "lat": -45.39,
  "lon": 108.27
}, {
  "lat": -44.71,
  "lon": 110.74
}, {
  "lat": -43.96,
  "lon": 113.21
}, {
  "lat": -43.14,
  "lon": 115.67
}, {
  "lat": -42.24,
  "lon": 118.11
}, {
  "lat": -41.28,
  "lon": 120.52
}, {
  "lat": -40.25,
  "lon": 122.9
}, {
  "lat": -39.16,
  "lon": 125.24
}, {
  "lat": -38.02,
  "lon": 127.54
}, {
  "lat": -36.81,
  "lon": 129.77
}, {
  "lat": -34.27,
  "lon": 134.07
}, {
  "lat": -32.95,
  "lon": 136.13
}, {
  "lat": -44.08,
  "lon": 106.26
}, {
  "lat": -43.43,
  "lon": 108.65
}, {
  "lat": -42.71,
  "lon": 111.05
}, {
  "lat": -41.93,
  "lon": 113.45
}, {
  "lat": -41.08,
  "lon": 115.84
}, {
  "lat": -40.16,
  "lon": 118.21
}, {
  "lat": -35.87,
  "lon": 127.38
}, {
  "lat": -34.66,
  "lon": 129.56
}, {
  "lat": -33.41,
  "lon": 131.68
}, {
  "lat": -42.76,
  "lon": 104.37
}, {
  "lat": -42.13,
  "lon": 106.68
}, {
  "lat": -41.45,
  "lon": 109.01
}, {
  "lat": -40.7,
  "lon": 111.34
}, {
  "lat": -39.88,
  "lon": 113.67
}, {
  "lat": -39,
  "lon": 116
}, {
  "lat": -38.06,
  "lon": 118.3
}, {
  "lat": -37.06,
  "lon": 120.59
}, {
  "lat": -33.72,
  "lon": 127.23
}, {
  "lat": -32.51,
  "lon": 129.35
}, {
  "lat": -31.27,
  "lon": 131.43
}, {
  "lat": -41.43,
  "lon": 102.59
}, {
  "lat": -40.83,
  "lon": 104.83
}, {
  "lat": -40.17,
  "lon": 107.08
}, {
  "lat": -39.45,
  "lon": 109.35
}, {
  "lat": -38.67,
  "lon": 111.62
}, {
  "lat": -37.82,
  "lon": 113.89
}, {
  "lat": -36.92,
  "lon": 116.15
}, {
  "lat": -35.95,
  "lon": 118.4
}, {
  "lat": -40.1,
  "lon": 100.92
}, {
  "lat": -39.52,
  "lon": 103.08
}, {
  "lat": -38.89,
  "lon": 105.26
}, {
  "lat": -38.19,
  "lon": 107.46
}, {
  "lat": -37.44,
  "lon": 109.67
}, {
  "lat": -36.63,
  "lon": 111.88
}, {
  "lat": -35.76,
  "lon": 114.09
}, {
  "lat": -34.83,
  "lon": 116.3
}, {
  "lat": -33.85,
  "lon": 118.48
}, {
  "lat": -32.82,
  "lon": 120.65
}, {
  "lat": -38.78,
  "lon": 99.34
}, {
  "lat": -38.22,
  "lon": 101.43
}, {
  "lat": -37.61,
  "lon": 103.54
}, {
  "lat": -36.94,
  "lon": 105.67
}, {
  "lat": -36.21,
  "lon": 107.82
}, {
  "lat": -35.43,
  "lon": 109.98
}, {
  "lat": -34.59,
  "lon": 112.13
}, {
  "lat": -33.69,
  "lon": 114.29
}, {
  "lat": -32.75,
  "lon": 116.43
}, {
  "lat": -31.75,
  "lon": 118.56
}, {
  "lat": -30.71,
  "lon": 120.67
}, {
  "lat": -37.48,
  "lon": 97.86
}, {
  "lat": -36.93,
  "lon": 99.88
}, {
  "lat": -36.33,
  "lon": 101.92
}, {
  "lat": -35.68,
  "lon": 103.98
}, {
  "lat": -34.98,
  "lon": 106.07
}, {
  "lat": -34.22,
  "lon": 108.16
}, {
  "lat": -33.41,
  "lon": 110.27
}, {
  "lat": -32.55,
  "lon": 112.37
}, {
  "lat": -31.63,
  "lon": 114.47
}, {
  "lat": -30.67,
  "lon": 116.57
}, {
  "lat": -29.66,
  "lon": 118.64
}, {
  "lat": -28.61,
  "lon": 120.7
}, {
  "lat": -36.19,
  "lon": 96.47
}, {
  "lat": -35.65,
  "lon": 98.41
}, {
  "lat": -35.07,
  "lon": 100.39
}, {
  "lat": -34.43,
  "lon": 102.39
}, {
  "lat": -33.75,
  "lon": 104.41
}, {
  "lat": -33.02,
  "lon": 106.44
}, {
  "lat": -32.23,
  "lon": 108.49
}, {
  "lat": -31.4,
  "lon": 110.54
}, {
  "lat": -30.52,
  "lon": 112.6
}, {
  "lat": -29.59,
  "lon": 114.65
}, {
  "lat": -28.61,
  "lon": 116.69
}, {
  "lat": -27.59,
  "lon": 118.72
}, {
  "lat": -26.54,
  "lon": 120.72
}, {
  "lat": -34.91,
  "lon": 95.16
}, {
  "lat": -34.39,
  "lon": 97.03
}, {
  "lat": -33.82,
  "lon": 98.94
}, {
  "lat": -33.2,
  "lon": 100.87
}, {
  "lat": -32.53,
  "lon": 102.83
}, {
  "lat": -31.82,
  "lon": 104.81
}, {
  "lat": -31.06,
  "lon": 106.8
}, {
  "lat": -30.25,
  "lon": 108.8
}, {
  "lat": -29.4,
  "lon": 110.81
}, {
  "lat": -28.5,
  "lon": 112.81
}, {
  "lat": -27.55,
  "lon": 114.82
}, {
  "lat": -26.57,
  "lon": 116.81
}, {
  "lat": -25.54,
  "lon": 118.79
}, {
  "lat": -24.49,
  "lon": 120.75
}, {
  "lat": -33.67,
  "lon": 93.92
}, {
  "lat": -33.15,
  "lon": 95.73
}, {
  "lat": -28.28,
  "lon": 109.1
}, {
  "lat": -27.41,
  "lon": 111.06
}, {
  "lat": -26.49,
  "lon": 113.02
}, {
  "lat": -25.54,
  "lon": 114.98
}, {
  "lat": -24.55,
  "lon": 116.92
}, {
  "lat": -22.47,
  "lon": 120.77
}, {
  "lat": -23.55,
  "lon": 115.13
}, {
  "lat": -22.56,
  "lon": 117.03
}, {
  "lat": -17.47,
  "lon": 122.62
}, {
  "lat": 5.92,
  "lon": 150.21
}, {
  "lat": 45.36,
  "lon": 167.49
}, {
  "lat": 47,
  "lon": 168.67
}, {
  "lat": 2.92,
  "lon": 150.77
}, {
  "lat": 6.01,
  "lon": 151.83
}, {
  "lat": 4.51,
  "lon": 152.93
}, {
  "lat": 6.19,
  "lon": 155.22
}, {
  "lat": 7.96,
  "lon": 157.66
}, {
  "lat": 8.06,
  "lon": 159.52
}, {
  "lat": 9.8,
  "lon": 160.25
}, {
  "lat": 20.88,
  "lon": 165.2
}, {
  "lat": 22.79,
  "lon": 166.13
}, {
  "lat": 17.78,
  "lon": 178.86
}, {
  "lat": 35.99,
  "lon": 173.56
}, {
  "lat": 43.96,
  "lon": 169.01
}, {
  "lat": 40.98,
  "lon": 171.95
}, {
  "lat": 37.78,
  "lon": 174.76
}, {
  "lat": 45.62,
  "lon": 170.21
}, {
  "lat": 44.19,
  "lon": 171.71
}, {
  "lat": 42.69,
  "lon": 173.18
}, {
  "lat": 41.14,
  "lon": 174.61
}, {
  "lat": 39.53,
  "lon": 176.01
}, {
  "lat": 37.87,
  "lon": 177.38
}, {
  "lat": 39.59,
  "lon": 178.67
}, {
  "lat": 3.66,
  "lon": 143.24
}, {
  "lat": 4.63,
  "lon": 141.88
}, {
  "lat": 5.63,
  "lon": 140.48
}, {
  "lat": 6.66,
  "lon": 139.04
}, {
  "lat": 12.01,
  "lon": 131.26
}, {
  "lat": 14.2,
  "lon": 127.9
}, {
  "lat": 15.3,
  "lon": 126.17
}, {
  "lat": 16.39,
  "lon": 124.41
}, {
  "lat": 17.47,
  "lon": 122.62
}, {
  "lat": 20.6,
  "lon": 117.13
}, {
  "lat": 2.78,
  "lon": 141.88
}, {
  "lat": 3.76,
  "lon": 140.48
}, {
  "lat": 2.86,
  "lon": 139.04
}, {
  "lat": 4.76,
  "lon": 139.04
}, {
  "lat": 1.94,
  "lon": 137.56
}, {
  "lat": 3.87,
  "lon": 137.56
}, {
  "lat": 5.79,
  "lon": 137.56
}, {
  "lat": 0.98,
  "lon": 136.04
}, {
  "lat": 2.94,
  "lon": 136.04
}, {
  "lat": 4.89,
  "lon": 136.04
}, {
  "lat": 1.98,
  "lon": 134.49
}, {
  "lat": 3.96,
  "lon": 134.49
}, {
  "lat": 5.93,
  "lon": 134.49
}, {
  "lat": 1,
  "lon": 132.89
}, {
  "lat": 3.01,
  "lon": 132.89
}, {
  "lat": 0,
  "lon": 131.26
}, {
  "lat": 2.03,
  "lon": 131.26
}, {
  "lat": 4.05,
  "lon": 131.26
}, {
  "lat": 8.07,
  "lon": 131.26
}, {
  "lat": 3.07,
  "lon": 129.6
}, {
  "lat": 0,
  "lon": 127.9
}, {
  "lat": 2.07,
  "lon": 127.9
}, {
  "lat": -9.32,
  "lon": 126.17
}, {
  "lat": -7.27,
  "lon": 126.17
}, {
  "lat": 3.13,
  "lon": 126.17
}, {
  "lat": 9.32,
  "lon": 126.17
}, {
  "lat": -12.44,
  "lon": 124.41
}, {
  "lat": -10.41,
  "lon": 124.41
}, {
  "lat": -8.36,
  "lon": 124.41
}, {
  "lat": -6.29,
  "lon": 124.41
}, {
  "lat": 0,
  "lon": 124.41
}, {
  "lat": 2.11,
  "lon": 124.41
}, {
  "lat": 8.36,
  "lon": 124.41
}, {
  "lat": 10.41,
  "lon": 124.41
}, {
  "lat": -13.53,
  "lon": 122.62
}, {
  "lat": -11.51,
  "lon": 122.62
}, {
  "lat": -9.46,
  "lon": 122.62
}, {
  "lat": -16.59,
  "lon": 120.81
}, {
  "lat": -14.61,
  "lon": 120.81
}, {
  "lat": 4.23,
  "lon": 144.98
}, {
  "lat": 5.22,
  "lon": 143.64
}, {
  "lat": 5.8,
  "lon": 145.41
}, {
  "lat": 6.38,
  "lon": 147.18
}, {
  "lat": 6.23,
  "lon": 142.26
}, {
  "lat": 6.83,
  "lon": 144.06
}, {
  "lat": 7.42,
  "lon": 145.86
}, {
  "lat": 8,
  "lon": 147.66
}, {
  "lat": 7.27,
  "lon": 140.84
}, {
  "lat": 7.88,
  "lon": 142.66
}, {
  "lat": 8.49,
  "lon": 144.49
}, {
  "lat": 9.08,
  "lon": 146.32
}, {
  "lat": 9.67,
  "lon": 148.16
}, {
  "lat": 10.25,
  "lon": 150
}, {
  "lat": 8.33,
  "lon": 139.38
}, {
  "lat": 8.96,
  "lon": 141.22
}, {
  "lat": 9.58,
  "lon": 143.07
}, {
  "lat": 12.47,
  "lon": 142.02
}, {
  "lat": 13.11,
  "lon": 143.94
}, {
  "lat": 14.3,
  "lon": 142.44
}, {
  "lat": 14.94,
  "lon": 144.41
}, {
  "lat": 12.72,
  "lon": 133.13
}, {
  "lat": 13.43,
  "lon": 135.03
}, {
  "lat": 14.13,
  "lon": 136.95
}, {
  "lat": 16.16,
  "lon": 142.88
}, {
  "lat": 16.81,
  "lon": 144.89
}, {
  "lat": 13.84,
  "lon": 131.46
}, {
  "lat": 14.58,
  "lon": 133.37
}, {
  "lat": 15.3,
  "lon": 135.31
}, {
  "lat": 16.02,
  "lon": 137.28
}, {
  "lat": 17.4,
  "lon": 141.3
}, {
  "lat": 18.07,
  "lon": 143.34
}, {
  "lat": 18.71,
  "lon": 145.39
}, {
  "lat": 14.97,
  "lon": 129.77
}, {
  "lat": 15.73,
  "lon": 131.68
}, {
  "lat": 16.48,
  "lon": 133.62
}, {
  "lat": 17.22,
  "lon": 135.61
}, {
  "lat": 17.95,
  "lon": 137.62
}, {
  "lat": 18.66,
  "lon": 139.67
}, {
  "lat": 19.35,
  "lon": 141.73
}, {
  "lat": 20.01,
  "lon": 143.81
}, {
  "lat": 20.65,
  "lon": 145.91
}, {
  "lat": 21.26,
  "lon": 148.01
}, {
  "lat": 21.85,
  "lon": 150.11
}, {
  "lat": 16.09,
  "lon": 128.03
}, {
  "lat": 16.88,
  "lon": 129.94
}, {
  "lat": 17.66,
  "lon": 131.9
}, {
  "lat": 18.42,
  "lon": 133.89
}, {
  "lat": 19.18,
  "lon": 135.92
}, {
  "lat": 19.92,
  "lon": 137.98
}, {
  "lat": 20.63,
  "lon": 140.07
}, {
  "lat": 21.32,
  "lon": 142.18
}, {
  "lat": 21.99,
  "lon": 144.31
}, {
  "lat": 22.62,
  "lon": 146.45
}, {
  "lat": 23.22,
  "lon": 148.6
}, {
  "lat": 23.79,
  "lon": 150.74
}, {
  "lat": 17.21,
  "lon": 126.26
}, {
  "lat": 18.02,
  "lon": 128.17
}, {
  "lat": 18.83,
  "lon": 130.13
}, {
  "lat": 19.63,
  "lon": 132.13
}, {
  "lat": 20.41,
  "lon": 134.17
}, {
  "lat": 21.18,
  "lon": 136.24
}, {
  "lat": 21.92,
  "lon": 138.36
}, {
  "lat": 22.64,
  "lon": 140.49
}, {
  "lat": 23.33,
  "lon": 142.65
}, {
  "lat": 23.99,
  "lon": 144.83
}, {
  "lat": 24.61,
  "lon": 147.02
}, {
  "lat": 25.2,
  "lon": 149.21
}, {
  "lat": 25.75,
  "lon": 151.4
}, {
  "lat": 26.26,
  "lon": 153.57
}, {
  "lat": 18.31,
  "lon": 124.47
}, {
  "lat": 19.16,
  "lon": 126.36
}, {
  "lat": 20,
  "lon": 128.32
}, {
  "lat": 20.82,
  "lon": 130.32
}, {
  "lat": 21.64,
  "lon": 132.37
}, {
  "lat": 22.44,
  "lon": 134.46
}, {
  "lat": 23.21,
  "lon": 136.58
}, {
  "lat": 23.96,
  "lon": 138.75
}, {
  "lat": 24.68,
  "lon": 140.94
}, {
  "lat": 25.36,
  "lon": 143.15
}, {
  "lat": 26.01,
  "lon": 145.37
}, {
  "lat": 26.63,
  "lon": 147.61
}, {
  "lat": 27.2,
  "lon": 149.85
}, {
  "lat": 27.73,
  "lon": 152.08
}, {
  "lat": 19.41,
  "lon": 122.64
}, {
  "lat": 20.28,
  "lon": 124.53
}, {
  "lat": 21.15,
  "lon": 126.47
}, {
  "lat": 22.01,
  "lon": 128.47
}, {
  "lat": 22.86,
  "lon": 130.52
}, {
  "lat": 23.69,
  "lon": 132.62
}, {
  "lat": 24.49,
  "lon": 134.76
}, {
  "lat": 25.27,
  "lon": 136.94
}, {
  "lat": 26.02,
  "lon": 139.15
}, {
  "lat": 26.74,
  "lon": 141.4
}, {
  "lat": 27.42,
  "lon": 143.66
}, {
  "lat": 28.06,
  "lon": 145.94
}, {
  "lat": 28.65,
  "lon": 148.23
}, {
  "lat": 29.2,
  "lon": 150.51
}, {
  "lat": 29.71,
  "lon": 152.79
}, {
  "lat": 20.48,
  "lon": 120.79
}, {
  "lat": 21.38,
  "lon": 122.66
}, {
  "lat": 22.29,
  "lon": 124.59
}, {
  "lat": 23.18,
  "lon": 126.58
}, {
  "lat": 24.06,
  "lon": 128.63
}, {
  "lat": 24.92,
  "lon": 130.73
}, {
  "lat": 25.76,
  "lon": 132.88
}, {
  "lat": 26.58,
  "lon": 135.08
}, {
  "lat": 27.36,
  "lon": 137.31
}, {
  "lat": 28.11,
  "lon": 139.58
}, {
  "lat": 28.82,
  "lon": 141.88
}, {
  "lat": 29.49,
  "lon": 144.2
}, {
  "lat": 30.11,
  "lon": 146.53
}, {
  "lat": 30.69,
  "lon": 148.87
}, {
  "lat": 31.21,
  "lon": 151.21
}, {
  "lat": 31.69,
  "lon": 153.53
}, {
  "lat": 21.53,
  "lon": 118.92
}, {
  "lat": 22.47,
  "lon": 120.77
}, {
  "lat": 23.4,
  "lon": 122.68
}, {
  "lat": 24.33,
  "lon": 124.66
}, {
  "lat": 25.24,
  "lon": 126.7
}, {
  "lat": 26.14,
  "lon": 128.8
}, {
  "lat": 27.02,
  "lon": 130.95
}, {
  "lat": 27.87,
  "lon": 133.16
}, {
  "lat": 28.69,
  "lon": 135.41
}, {
  "lat": 29.47,
  "lon": 137.7
}, {
  "lat": 30.21,
  "lon": 140.03
}, {
  "lat": 30.91,
  "lon": 142.39
}, {
  "lat": 31.57,
  "lon": 144.76
}, {
  "lat": 32.17,
  "lon": 147.15
}, {
  "lat": 32.72,
  "lon": 149.55
}, {
  "lat": 33.22,
  "lon": 151.93
}, {
  "lat": 22.56,
  "lon": 117.03
}, {
  "lat": 23.52,
  "lon": 118.85
}, {
  "lat": 24.49,
  "lon": 120.75
}, {
  "lat": 25.45,
  "lon": 122.71
}, {
  "lat": 26.4,
  "lon": 124.73
}, {
  "lat": 27.33,
  "lon": 126.82
}, {
  "lat": 28.24,
  "lon": 128.97
}, {
  "lat": 29.13,
  "lon": 131.18
}, {
  "lat": 29.99,
  "lon": 133.45
}, {
  "lat": 30.81,
  "lon": 135.76
}, {
  "lat": 31.59,
  "lon": 138.11
}, {
  "lat": 32.33,
  "lon": 140.5
}, {
  "lat": 33.01,
  "lon": 142.92
}, {
  "lat": 33.65,
  "lon": 145.36
}, {
  "lat": 34.23,
  "lon": 147.8
}, {
  "lat": 34.75,
  "lon": 150.25
}, {
  "lat": 23.55,
  "lon": 115.13
}, {
  "lat": 24.55,
  "lon": 116.92
}, {
  "lat": 25.54,
  "lon": 118.79
}, {
  "lat": 26.54,
  "lon": 120.72
}, {
  "lat": 27.52,
  "lon": 122.73
}, {
  "lat": 28.49,
  "lon": 124.81
}, {
  "lat": 29.44,
  "lon": 126.95
}, {
  "lat": 30.37,
  "lon": 129.16
}, {
  "lat": 31.27,
  "lon": 131.43
}, {
  "lat": 32.13,
  "lon": 133.75
}, {
  "lat": 32.95,
  "lon": 136.13
}, {
  "lat": 33.72,
  "lon": 138.54
}, {
  "lat": 34.44,
  "lon": 141
}, {
  "lat": 35.11,
  "lon": 143.48
}, {
  "lat": 35.73,
  "lon": 145.98
}, {
  "lat": 36.28,
  "lon": 148.48
}, {
  "lat": 25.54,
  "lon": 114.98
}, {
  "lat": 26.57,
  "lon": 116.81
}, {
  "lat": 27.59,
  "lon": 118.72
}, {
  "lat": 28.61,
  "lon": 120.7
}, {
  "lat": 29.62,
  "lon": 122.76
}, {
  "lat": 30.61,
  "lon": 124.88
}, {
  "lat": 31.58,
  "lon": 127.09
}, {
  "lat": 32.51,
  "lon": 129.35
}, {
  "lat": 35.09,
  "lon": 136.51
}, {
  "lat": 35.85,
  "lon": 139
}, {
  "lat": 36.56,
  "lon": 141.52
}, {
  "lat": 37.21,
  "lon": 144.07
}, {
  "lat": 37.79,
  "lon": 146.63
}, {
  "lat": 38.32,
  "lon": 149.2
}, {
  "lat": 27.55,
  "lon": 114.82
}, {
  "lat": 28.61,
  "lon": 116.69
}, {
  "lat": 29.66,
  "lon": 118.64
}, {
  "lat": 30.71,
  "lon": 120.67
}, {
  "lat": 31.74,
  "lon": 122.78
}, {
  "lat": 32.74,
  "lon": 124.97
}, {
  "lat": 38.66,
  "lon": 142.07
}, {
  "lat": 39.29,
  "lon": 144.68
}, {
  "lat": 29.59,
  "lon": 114.65
}, {
  "lat": 30.67,
  "lon": 116.57
}, {
  "lat": 31.75,
  "lon": 118.56
}, {
  "lat": 32.82,
  "lon": 120.65
}, {
  "lat": 33.86,
  "lon": 122.81
}, {
  "lat": 41.35,
  "lon": 145.34
}, {
  "lat": 41.88,
  "lon": 148.04
}, {
  "lat": 32.75,
  "lon": 116.43
}, {
  "lat": 33.85,
  "lon": 118.48
}, {
  "lat": 34.93,
  "lon": 120.62
}, {
  "lat": 43.39,
  "lon": 146.02
}, {
  "lat": 34.83,
  "lon": 116.3
}, {
  "lat": 31.29,
  "lon": 18.24
}, {
  "lat": 29.4,
  "lon": 19.13
}, {
  "lat": 29.71,
  "lon": 16.88
}, {
  "lat": 27.5,
  "lon": 19.99
}, {
  "lat": 27.81,
  "lon": 17.79
}, {
  "lat": 28.08,
  "lon": 15.54
}, {
  "lat": 25.6,
  "lon": 20.81
}, {
  "lat": 25.9,
  "lon": 18.67
}, {
  "lat": 26.17,
  "lon": 16.47
}, {
  "lat": 23.7,
  "lon": 21.6
}, {
  "lat": 23.99,
  "lon": 19.51
}, {
  "lat": 24.26,
  "lon": 17.36
}, {
  "lat": 24.5,
  "lon": 15.16
}, {
  "lat": 21.81,
  "lon": 22.37
}, {
  "lat": 22.09,
  "lon": 20.32
}, {
  "lat": 22.35,
  "lon": 18.22
}, {
  "lat": 22.58,
  "lon": 16.07
}, {
  "lat": 22.79,
  "lon": 13.87
}, {
  "lat": 19.94,
  "lon": 23.11
}, {
  "lat": 20.21,
  "lon": 21.11
}, {
  "lat": 20.45,
  "lon": 19.06
}, {
  "lat": 20.68,
  "lon": 16.95
}, {
  "lat": 20.88,
  "lon": 14.8
}, {
  "lat": 18.09,
  "lon": 23.82
}, {
  "lat": 18.34,
  "lon": 21.87
}, {
  "lat": 18.57,
  "lon": 19.86
}, {
  "lat": 18.78,
  "lon": 17.8
}, {
  "lat": 18.98,
  "lon": 15.69
}, {
  "lat": 19.15,
  "lon": 13.54
}, {
  "lat": 16.27,
  "lon": 24.51
}, {
  "lat": 16.49,
  "lon": 22.6
}, {
  "lat": 16.71,
  "lon": 20.64
}, {
  "lat": 16.91,
  "lon": 18.62
}, {
  "lat": 17.09,
  "lon": 16.56
}, {
  "lat": 17.25,
  "lon": 14.45
}, {
  "lat": 17.4,
  "lon": 12.3
}, {
  "lat": 14.47,
  "lon": 25.17
}, {
  "lat": 14.68,
  "lon": 23.31
}, {
  "lat": 14.87,
  "lon": 21.39
}, {
  "lat": 15.05,
  "lon": 19.42
}, {
  "lat": 15.22,
  "lon": 17.4
}, {
  "lat": 15.38,
  "lon": 15.33
}, {
  "lat": 15.51,
  "lon": 13.22
}, {
  "lat": 12.7,
  "lon": 25.81
}, {
  "lat": 12.89,
  "lon": 23.99
}, {
  "lat": 13.06,
  "lon": 22.11
}, {
  "lat": 13.23,
  "lon": 20.18
}, {
  "lat": 13.38,
  "lon": 18.21
}, {
  "lat": 13.52,
  "lon": 16.18
}, {
  "lat": 13.65,
  "lon": 14.12
}, {
  "lat": 10.97,
  "lon": 26.43
}, {
  "lat": 11.13,
  "lon": 24.65
}, {
  "lat": 11.29,
  "lon": 22.81
}, {
  "lat": 11.43,
  "lon": 20.93
}, {
  "lat": 11.57,
  "lon": 18.99
}, {
  "lat": 11.7,
  "lon": 17.01
}, {
  "lat": 11.81,
  "lon": 14.98
}, {
  "lat": 9.28,
  "lon": 27.03
}, {
  "lat": 9.42,
  "lon": 25.29
}, {
  "lat": 9.55,
  "lon": 23.49
}, {
  "lat": 9.68,
  "lon": 21.64
}, {
  "lat": 9.8,
  "lon": 19.75
}, {
  "lat": 9.91,
  "lon": 17.81
}, {
  "lat": 10.01,
  "lon": 15.82
}, {
  "lat": 10.1,
  "lon": 13.8
}, {
  "lat": 7.63,
  "lon": 27.61
}, {
  "lat": 7.74,
  "lon": 25.9
}, {
  "lat": 7.85,
  "lon": 24.14
}, {
  "lat": 7.96,
  "lon": 22.34
}, {
  "lat": 8.06,
  "lon": 20.48
}, {
  "lat": 8.15,
  "lon": 18.58
}, {
  "lat": 8.24,
  "lon": 16.64
}, {
  "lat": 8.32,
  "lon": 14.65
}, {
  "lat": 6.01,
  "lon": 28.17
}, {
  "lat": 6.1,
  "lon": 26.5
}, {
  "lat": 6.19,
  "lon": 24.78
}, {
  "lat": 6.28,
  "lon": 23.01
}, {
  "lat": 6.36,
  "lon": 21.19
}, {
  "lat": 6.43,
  "lon": 19.33
}, {
  "lat": 6.5,
  "lon": 17.43
}, {
  "lat": 6.57,
  "lon": 15.48
}, {
  "lat": 6.63,
  "lon": 13.5
}, {
  "lat": 4.44,
  "lon": 28.71
}, {
  "lat": 4.51,
  "lon": 27.07
}, {
  "lat": 4.58,
  "lon": 25.39
}, {
  "lat": 4.64,
  "lon": 23.66
}, {
  "lat": 4.7,
  "lon": 21.88
}, {
  "lat": 4.76,
  "lon": 20.06
}, {
  "lat": 4.81,
  "lon": 18.19
}, {
  "lat": 4.86,
  "lon": 16.28
}, {
  "lat": 4.91,
  "lon": 14.34
}, {
  "lat": 4.95,
  "lon": 12.36
}, {
  "lat": 2.92,
  "lon": 29.23
}, {
  "lat": 2.96,
  "lon": 27.63
}, {
  "lat": 3.01,
  "lon": 25.98
}, {
  "lat": 3.05,
  "lon": 24.29
}, {
  "lat": 3.09,
  "lon": 22.55
}, {
  "lat": 3.13,
  "lon": 20.76
}, {
  "lat": 3.16,
  "lon": 18.93
}, {
  "lat": 3.2,
  "lon": 17.06
}, {
  "lat": 3.23,
  "lon": 15.15
}, {
  "lat": 3.26,
  "lon": 13.21
}, {
  "lat": 3.28,
  "lon": 11.23
}, {
  "lat": 1.44,
  "lon": 29.74
}, {
  "lat": 1.46,
  "lon": 28.17
}, {
  "lat": 1.48,
  "lon": 26.56
}, {
  "lat": 1.5,
  "lon": 24.9
}, {
  "lat": 1.52,
  "lon": 23.19
}, {
  "lat": 1.54,
  "lon": 21.44
}, {
  "lat": 1.56,
  "lon": 19.65
}, {
  "lat": 1.58,
  "lon": 17.81
}, {
  "lat": 1.59,
  "lon": 15.94
}, {
  "lat": 1.61,
  "lon": 14.03
}, {
  "lat": 1.62,
  "lon": 12.09
}, {
  "lat": 1.63,
  "lon": 10.12
}, {
  "lat": 0,
  "lon": 30.23
}, {
  "lat": 0,
  "lon": 28.7
}, {
  "lat": 0,
  "lon": 27.12
}, {
  "lat": 0,
  "lon": 25.49
}, {
  "lat": 0,
  "lon": 23.82
}, {
  "lat": 0,
  "lon": 22.1
}, {
  "lat": 0,
  "lon": 20.35
}, {
  "lat": 0,
  "lon": 18.55
}, {
  "lat": 0,
  "lon": 16.71
}, {
  "lat": 0,
  "lon": 14.84
}, {
  "lat": 0,
  "lon": 12.93
}, {
  "lat": 0,
  "lon": 10.99
}, {
  "lat": 0,
  "lon": 9.03
}, {
  "lat": -1.44,
  "lon": 29.74
}, {
  "lat": -2.92,
  "lon": 29.23
}, {
  "lat": -1.46,
  "lon": 28.17
}, {
  "lat": -4.44,
  "lon": 28.71
}, {
  "lat": -2.96,
  "lon": 27.63
}, {
  "lat": -1.48,
  "lon": 26.56
}, {
  "lat": -6.01,
  "lon": 28.17
}, {
  "lat": -4.51,
  "lon": 27.07
}, {
  "lat": -3.01,
  "lon": 25.98
}, {
  "lat": -1.5,
  "lon": 24.9
}, {
  "lat": -7.63,
  "lon": 27.61
}, {
  "lat": -6.1,
  "lon": 26.5
}, {
  "lat": -4.58,
  "lon": 25.39
}, {
  "lat": -3.05,
  "lon": 24.29
}, {
  "lat": -1.52,
  "lon": 23.19
}, {
  "lat": -9.28,
  "lon": 27.03
}, {
  "lat": -7.74,
  "lon": 25.9
}, {
  "lat": -6.19,
  "lon": 24.78
}, {
  "lat": -4.64,
  "lon": 23.66
}, {
  "lat": -3.09,
  "lon": 22.55
}, {
  "lat": -1.54,
  "lon": 21.44
}, {
  "lat": -10.97,
  "lon": 26.43
}, {
  "lat": -9.42,
  "lon": 25.29
}, {
  "lat": -7.85,
  "lon": 24.14
}, {
  "lat": -6.28,
  "lon": 23.01
}, {
  "lat": -4.7,
  "lon": 21.88
}, {
  "lat": -3.13,
  "lon": 20.76
}, {
  "lat": -1.56,
  "lon": 19.65
}, {
  "lat": -12.7,
  "lon": 25.81
}, {
  "lat": -11.13,
  "lon": 24.65
}, {
  "lat": -9.55,
  "lon": 23.49
}, {
  "lat": -7.96,
  "lon": 22.34
}, {
  "lat": -6.36,
  "lon": 21.19
}, {
  "lat": -4.76,
  "lon": 20.06
}, {
  "lat": -3.16,
  "lon": 18.93
}, {
  "lat": -1.58,
  "lon": 17.81
}, {
  "lat": -14.47,
  "lon": 25.17
}, {
  "lat": -12.89,
  "lon": 23.99
}, {
  "lat": -11.29,
  "lon": 22.81
}, {
  "lat": -9.68,
  "lon": 21.64
}, {
  "lat": -8.06,
  "lon": 20.48
}, {
  "lat": -6.43,
  "lon": 19.33
}, {
  "lat": -4.81,
  "lon": 18.19
}, {
  "lat": -3.2,
  "lon": 17.06
}, {
  "lat": -1.59,
  "lon": 15.94
}, {
  "lat": -16.27,
  "lon": 24.51
}, {
  "lat": -14.68,
  "lon": 23.31
}, {
  "lat": -13.06,
  "lon": 22.11
}, {
  "lat": -11.43,
  "lon": 20.93
}, {
  "lat": -9.8,
  "lon": 19.75
}, {
  "lat": -8.15,
  "lon": 18.58
}, {
  "lat": -6.5,
  "lon": 17.43
}, {
  "lat": -4.86,
  "lon": 16.28
}, {
  "lat": -3.23,
  "lon": 15.15
}, {
  "lat": -1.61,
  "lon": 14.03
}, {
  "lat": -18.09,
  "lon": 23.82
}, {
  "lat": -16.49,
  "lon": 22.6
}, {
  "lat": -14.87,
  "lon": 21.39
}, {
  "lat": -13.23,
  "lon": 20.18
}, {
  "lat": -11.57,
  "lon": 18.99
}, {
  "lat": -9.91,
  "lon": 17.81
}, {
  "lat": -8.24,
  "lon": 16.64
}, {
  "lat": -6.57,
  "lon": 15.48
}, {
  "lat": -4.91,
  "lon": 14.34
}, {
  "lat": -3.26,
  "lon": 13.21
}, {
  "lat": -1.62,
  "lon": 12.09
}, {
  "lat": -19.94,
  "lon": 23.11
}, {
  "lat": -18.34,
  "lon": 21.87
}, {
  "lat": -16.71,
  "lon": 20.64
}, {
  "lat": -15.05,
  "lon": 19.42
}, {
  "lat": -13.38,
  "lon": 18.21
}, {
  "lat": -11.7,
  "lon": 17.01
}, {
  "lat": -10.01,
  "lon": 15.82
}, {
  "lat": -8.32,
  "lon": 14.65
}, {
  "lat": -6.63,
  "lon": 13.5
}, {
  "lat": -4.95,
  "lon": 12.36
}, {
  "lat": -3.28,
  "lon": 11.23
}, {
  "lat": -1.63,
  "lon": 10.12
}, {
  "lat": -21.81,
  "lon": 22.37
}, {
  "lat": -20.21,
  "lon": 21.11
}, {
  "lat": -18.57,
  "lon": 19.86
}, {
  "lat": -16.91,
  "lon": 18.62
}, {
  "lat": -15.22,
  "lon": 17.4
}, {
  "lat": -13.52,
  "lon": 16.18
}, {
  "lat": -11.81,
  "lon": 14.98
}, {
  "lat": -10.1,
  "lon": 13.8
}, {
  "lat": -8.39,
  "lon": 12.63
}, {
  "lat": -6.68,
  "lon": 11.48
}, {
  "lat": -4.98,
  "lon": 10.35
}, {
  "lat": -3.3,
  "lon": 9.23
}, {
  "lat": -23.7,
  "lon": 21.6
}, {
  "lat": -22.09,
  "lon": 20.32
}, {
  "lat": -20.45,
  "lon": 19.06
}, {
  "lat": -18.78,
  "lon": 17.8
}, {
  "lat": -17.09,
  "lon": 16.56
}, {
  "lat": -15.38,
  "lon": 15.33
}, {
  "lat": -13.65,
  "lon": 14.12
}, {
  "lat": -11.92,
  "lon": 12.92
}, {
  "lat": -10.18,
  "lon": 11.74
}, {
  "lat": -8.45,
  "lon": 10.58
}, {
  "lat": -6.72,
  "lon": 9.44
}, {
  "lat": -5.01,
  "lon": 8.31
}, {
  "lat": -25.6,
  "lon": 20.81
}, {
  "lat": -23.99,
  "lon": 19.51
}, {
  "lat": -22.35,
  "lon": 18.22
}, {
  "lat": -20.68,
  "lon": 16.95
}, {
  "lat": -18.98,
  "lon": 15.69
}, {
  "lat": -17.25,
  "lon": 14.45
}, {
  "lat": -15.51,
  "lon": 13.22
}, {
  "lat": -13.76,
  "lon": 12.01
}, {
  "lat": -12.01,
  "lon": 10.82
}, {
  "lat": -10.25,
  "lon": 9.65
}, {
  "lat": -8.5,
  "lon": 8.5
}, {
  "lat": -6.76,
  "lon": 7.36
}, {
  "lat": -5.03,
  "lon": 6.25
}, {
  "lat": -27.5,
  "lon": 19.99
}, {
  "lat": -25.9,
  "lon": 18.67
}, {
  "lat": -24.26,
  "lon": 17.36
}, {
  "lat": -22.58,
  "lon": 16.07
}, {
  "lat": -20.88,
  "lon": 14.8
}, {
  "lat": -19.15,
  "lon": 13.54
}, {
  "lat": -17.4,
  "lon": 12.3
}, {
  "lat": -15.63,
  "lon": 11.08
}, {
  "lat": -13.86,
  "lon": 9.88
}, {
  "lat": -12.08,
  "lon": 8.7
}, {
  "lat": -10.31,
  "lon": 7.53
}, {
  "lat": -8.54,
  "lon": 6.39
}, {
  "lat": -6.79,
  "lon": 5.27
}, {
  "lat": -29.4,
  "lon": 19.13
}, {
  "lat": -27.81,
  "lon": 17.79
}, {
  "lat": -26.17,
  "lon": 16.47
}, {
  "lat": -24.5,
  "lon": 15.16
}, {
  "lat": -22.79,
  "lon": 13.87
}, {
  "lat": -21.06,
  "lon": 12.6
}, {
  "lat": -19.3,
  "lon": 11.35
}, {
  "lat": -17.52,
  "lon": 10.11
}, {
  "lat": -15.73,
  "lon": 8.9
}, {
  "lat": -13.94,
  "lon": 7.71
}, {
  "lat": -12.14,
  "lon": 6.54
}, {
  "lat": -10.35,
  "lon": 5.4
}, {
  "lat": -8.57,
  "lon": 4.27
}, {
  "lat": -6.8,
  "lon": 3.17
}, {
  "lat": -29.71,
  "lon": 16.88
}, {
  "lat": -28.08,
  "lon": 15.54
}, {
  "lat": -26.42,
  "lon": 14.22
}, {
  "lat": -24.71,
  "lon": 12.91
}, {
  "lat": -22.97,
  "lon": 11.63
}, {
  "lat": -21.21,
  "lon": 10.36
}, {
  "lat": -19.43,
  "lon": 9.12
}, {
  "lat": -17.62,
  "lon": 7.9
}, {
  "lat": -15.81,
  "lon": 6.7
}, {
  "lat": -14,
  "lon": 5.53
}, {
  "lat": -12.18,
  "lon": 4.37
}, {
  "lat": -10.38,
  "lon": 3.24
}, {
  "lat": -8.59,
  "lon": 2.14
}, {
  "lat": -6.81,
  "lon": 1.06
}, {
  "lat": -5.06,
  "lon": 0
}, {
  "lat": -31.61,
  "lon": 15.94
}, {
  "lat": -29.99,
  "lon": 14.58
}, {
  "lat": -28.33,
  "lon": 13.24
}, {
  "lat": -26.63,
  "lon": 11.92
}, {
  "lat": -24.89,
  "lon": 10.62
}, {
  "lat": -23.13,
  "lon": 9.35
}, {
  "lat": -21.34,
  "lon": 8.1
}, {
  "lat": -19.52,
  "lon": 6.87
}, {
  "lat": -17.7,
  "lon": 5.66
}, {
  "lat": -15.87,
  "lon": 4.48
}, {
  "lat": -14.04,
  "lon": 3.32
}, {
  "lat": -12.21,
  "lon": 2.19
}, {
  "lat": -10.39,
  "lon": 1.08
}, {
  "lat": -8.59,
  "lon": 0
}, {
  "lat": -31.89,
  "lon": 13.59
}, {
  "lat": -30.23,
  "lon": 12.23
}, {
  "lat": -28.54,
  "lon": 10.9
}, {
  "lat": -26.81,
  "lon": 9.59
}, {
  "lat": -25.04,
  "lon": 8.3
}, {
  "lat": -23.25,
  "lon": 7.04
}, {
  "lat": -21.43,
  "lon": 5.8
}, {
  "lat": -19.6,
  "lon": 4.59
}, {
  "lat": -17.75,
  "lon": 3.4
}, {
  "lat": -15.9,
  "lon": 2.24
}, {
  "lat": -14.06,
  "lon": 1.11
}, {
  "lat": -12.22,
  "lon": 0
}, {
  "lat": -36.89,
  "lon": 15.37
}, {
  "lat": -32.12,
  "lon": 11.19
}, {
  "lat": -30.44,
  "lon": 9.84
}, {
  "lat": -28.71,
  "lon": 8.52
}, {
  "lat": -26.95,
  "lon": 7.22
}, {
  "lat": -25.15,
  "lon": 5.95
}, {
  "lat": -23.33,
  "lon": 4.71
}, {
  "lat": -21.49,
  "lon": 3.49
}, {
  "lat": -19.64,
  "lon": 2.3
}, {
  "lat": -17.78,
  "lon": 1.14
}, {
  "lat": -15.92,
  "lon": 0
}, {
  "lat": -37.19,
  "lon": 12.9
}, {
  "lat": -33.99,
  "lon": 10.11
}, {
  "lat": -32.32,
  "lon": 8.74
}, {
  "lat": -30.6,
  "lon": 7.41
}, {
  "lat": -28.84,
  "lon": 6.11
}, {
  "lat": -27.05,
  "lon": 4.83
}, {
  "lat": -25.23,
  "lon": 3.58
}, {
  "lat": -23.39,
  "lon": 2.36
}, {
  "lat": -21.53,
  "lon": 1.16
}, {
  "lat": -19.65,
  "lon": 0
}, {
  "lat": -40.5,
  "lon": 13.27
}, {
  "lat": -35.83,
  "lon": 8.99
}, {
  "lat": -34.17,
  "lon": 7.61
}, {
  "lat": -32.46,
  "lon": 6.27
}, {
  "lat": -30.72,
  "lon": 4.96
}, {
  "lat": -28.93,
  "lon": 3.67
}, {
  "lat": -27.11,
  "lon": 2.42
}, {
  "lat": -25.27,
  "lon": 1.19
}, {
  "lat": -23.4,
  "lon": 0
}, {
  "lat": -42.25,
  "lon": 12.15
}, {
  "lat": -39.23,
  "lon": 9.24
}, {
  "lat": -35.99,
  "lon": 6.44
}, {
  "lat": -34.3,
  "lon": 5.09
}, {
  "lat": -32.56,
  "lon": 3.77
}, {
  "lat": -30.79,
  "lon": 2.48
}, {
  "lat": -28.97,
  "lon": 1.23
}, {
  "lat": -27.13,
  "lon": 0
}, {
  "lat": -43.96,
  "lon": 10.99
}, {
  "lat": -42.5,
  "lon": 9.51
}, {
  "lat": -36.1,
  "lon": 3.88
}, {
  "lat": -34.38,
  "lon": 2.55
}, {
  "lat": -32.61,
  "lon": 1.26
}, {
  "lat": -30.81,
  "lon": 0
}, {
  "lat": -45.62,
  "lon": 9.79
}, {
  "lat": -44.19,
  "lon": 8.29
}, {
  "lat": -42.69,
  "lon": 6.82
}, {
  "lat": -36.16,
  "lon": 1.29
}, {
  "lat": -34.41,
  "lon": 0
}, {
  "lat": -47.24,
  "lon": 8.54
}, {
  "lat": -45.83,
  "lon": 7.03
}, {
  "lat": -44.35,
  "lon": 5.55
}, {
  "lat": -42.82,
  "lon": 4.11
}, {
  "lat": -41.23,
  "lon": 2.7
}, {
  "lat": -37.9,
  "lon": 0
}, {
  "lat": -48.81,
  "lon": 7.25
}, {
  "lat": -47.42,
  "lon": 5.72
}, {
  "lat": -45.97,
  "lon": 4.23
}, {
  "lat": -44.45,
  "lon": 2.78
}, {
  "lat": -42.89,
  "lon": 1.37
}, {
  "lat": -41.26,
  "lon": 0
}, {
  "lat": -50.33,
  "lon": 5.9
}, {
  "lat": -48.96,
  "lon": 4.36
}, {
  "lat": -47.53,
  "lon": 2.87
}, {
  "lat": -46.04,
  "lon": 1.41
}, {
  "lat": -44.49,
  "lon": 0
}, {
  "lat": -51.79,
  "lon": 4.5
}, {
  "lat": -50.44,
  "lon": 2.96
}, {
  "lat": -49.03,
  "lon": 1.46
}, {
  "lat": -47.56,
  "lon": 0
}, {
  "lat": -51.87,
  "lon": 1.5
}, {
  "lat": -50.48,
  "lon": 0
}, {
  "lat": -53.24,
  "lon": 0
}]
export default grid


// WEBPACK FOOTER //
// ./src/plugins/globe/utils/grid.js